// This file is auto-generated. Do not edit directly.
import type { ProductDatabase } from '../types';

export const defaultProductDatabase: ProductDatabase = {
  "products": {
    "volume_root_clips": {
      "name": "Volume Root Clips",
      "brand": "Bounce Curl",
      "product_categories": [
        "accessories"
      ],
      "tags": [
        "style",
        "featured"
      ],
      "description": "These clips are specially designed to help you create volume at the roots of your hair",
      "buy_links": [
        {
          "url": "https://glnk.io/x26q/curlsbot3oe",
          "retailer": "Bounce Curl"
        }
      ],
      "id": "volume_root_clips",
      "systems_excluded": []
    },
    "volume_edgelift_brush": {
      "name": "Volume EdgeLift Brush",
      "brand": "Bounce Curl",
      "product_categories": [
        "accessories"
      ],
      "tags": [
        "style",
        "featured"
      ],
      "description": "The Volume EdgeLift Brush is a unique tool that helps you create voluminous curls/waves",
      "buy_links": [
        {
          "url": "https://glnk.io/x26q/curlsbot3l6",
          "retailer": "Bounce Curl"
        }
      ],
      "id": "volume_edgelift_brush",
      "systems_excluded": []
    },
    "define_edgelift_brush": {
      "name": "Define EdgeLift Brush",
      "brand": "Bounce Curl",
      "product_categories": [
        "accessories"
      ],
      "tags": [
        "style",
        "featured"
      ],
      "description": "The Define EdgeLift Brush is a unique brush that helps define your curls/waves",
      "buy_links": [
        {
          "url": "https://glnk.io/x26q/curlsbot6au",
          "retailer": "Bounce Curl"
        }
      ],
      "id": "define_edgelift_brush",
      "systems_excluded": []
    },
    "universal_diffuser": {
      "name": "Universal Diffuser",
      "product_categories": [
        "accessories"
      ],
      "brand": "Bio Ionic",
      "tags": [
        "style",
        "featured"
      ],
      "description": "Turn any hairdryer into a diffuser with this attachment",
      "buy_links": [
        {
          "url": "https://click.linksynergy.com/link?id=9QcV0uNyab0&offerid=696429.4479416&type=2&murl=https%3a%2f%2fbioionic.com%2fproducts%2funiversal-diffuser-black%3fvariant%3d44904716697920%26utm_source%3dgoogle%26utm_medium%3dpaid%26utm_campaign%3dshopping%26utm_term%3d16",
          "retailer": "Bio Ionic"
        }
      ],
      "id": "universal_diffuser",
      "systems_excluded": []
    },
    "curly_girl_microfiber_super_absorbent_anti_frizz_hair_towel": {
      "name": "Curly Girl Microfiber Super Absorbent Anti Frizz Hair Towel",
      "product_categories": [
        "accessories"
      ],
      "brand": "Curly Girl Store",
      "tags": [
        "style",
        "featured"
      ],
      "buy_links": [
        {
          "url": "https://amzn.to/4iXc9Cv",
          "retailer": "Amazon"
        }
      ],
      "asin": "B09D8PL1N5",
      "description": "Help your hair dry faster and reduce frizz with a microfiber towel.",
      "id": "curly_girl_microfiber_super_absorbent_anti_frizz_hair_towel",
      "systems_excluded": []
    },
    "curl_friendly_soft_headbands": {
      "name": "Curl friendly soft headbands",
      "brand": "By the creator of CurlsBot",
      "product_categories": [
        "accessories"
      ],
      "tags": [
        "style",
        "featured"
      ],
      "buy_links": [
        {
          "url": "https://eldritchsalvage.etsy.com",
          "retailer": "Eldritch Salvage"
        }
      ],
      "description": "These headbands are made by the creator of CurlsBot from soft, stretchy fabric that won't snag or pull on your curls. They're perfect for keeping your hair out of your face and creating lovely styles that won't damage your hair.",
      "id": "curl_friendly_soft_headbands",
      "systems_excluded": []
    },
    "curly_hair_sleep_cozy": {
      "name": "Curly Hair Sleep Cozy",
      "brand": "Lohy",
      "tags": [
        "style",
        "featured"
      ],
      "product_categories": [
        "accessories"
      ],
      "buy_links": [
        {
          "url": "https://lohy.com.au/products/curly-hair-products-lohy-cozy-turban?aff=49",
          "retailer": "Lohy",
          "country": "AU"
        }
      ],
      "description": "Protect your hair while you sleep with this cozy turban",
      "id": "curly_hair_sleep_cozy",
      "systems_excluded": []
    },
    "curly_hair_accessories_kit": {
      "name": "Curly Hair Accessories Kit",
      "brand": "Lohy",
      "description": "A full kit of Lohy's most useful accessories such as a sleep turban, volume clips, and innovative hydration glove",
      "tags": [
        "style",
        "featured"
      ],
      "product_categories": [
        "accessories"
      ],
      "buy_links": [
        {
          "url": "https://lohy.com.au/products/curls-frills-hair-kit?aff=49",
          "retailer": "Lohy",
          "country": "AU"
        }
      ],
      "id": "curly_hair_accessories_kit",
      "systems_excluded": []
    },
    "pop-up_curl_diffuser": {
      "name": "Pop-Up Curl Diffuser",
      "brand": "Curl Keeper",
      "product_categories": [
        "accessories"
      ],
      "tags": [
        "style",
        "featured"
      ],
      "description": "Great for travel though I've used it at home for years because it's so easy to store",
      "buy_links": [
        {
          "url": "https://curlkeeper.com/r?id=9l8okf",
          "retailer": "Curl Keeper"
        }
      ],
      "id": "pop-up_curl_diffuser",
      "systems_excluded": []
    },
    "mud_pie_clay_clarifying_treatment": {
      "name": "Mud Pie Clay Clarifying Treatment",
      "brand": "Ecoslay",
      "ingredients_raw": "distilled water, aloe barbadensis leaf juice, cirtus aurantium amara distillate, bentonite, propanediol, apple cider vinegar, dermasoft eco 1388, potassium sorbate, sodium thiosulfate",
      "product_categories": [
        "clarifying_shampoos"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity",
        "low_porosity",
        "featured",
        "black_owned",
        "woman_owned",
        "small_business"
      ],
      "buy_links": [
        {
          "url": "http://ecoslay.sjv.io/EEqZBe",
          "retailer": "Ecoslay"
        }
      ],
      "id": "mud_pie_clay_clarifying_treatment",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 1,
          "film_forming_humectants_number": 1,
          "emollients_number": 0,
          "simple_humectants": [
            "Propanediol"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [],
          "score": -82
        },
        "porosity": {
          "high": 80,
          "low": 100
        }
      }
    },
    "clarifying_shampoo": {
      "name": "Clarifying Shampoo",
      "brand": "Moroccanoil",
      "product_categories": [
        "clarifying_shampoos"
      ],
      "tags": [
        "low_porosity",
        "normal_porosity",
        "featured"
      ],
      "buy_links": [
        {
          "url": "https://amzn.to/4iSDfKT",
          "retailer": "Amazon",
          "country": "AU"
        },
        {
          "url": "https://fave.co/3PMQGyT",
          "retailer": "Moroccanoil"
        },
        {
          "url": "https://go.skimresources.com?id=276362X1762442&xs=1&url=https%3A%2F%2Fau.moroccanoil.com%2Fproducts%2Fclarifying-shampoo",
          "retailer": "Moroccanoil",
          "country": "AU"
        }
      ],
      "description": "This shampoo has some stronger cleansers, but that's fine in a clarifying shampoo because you're only using it once in a while. It's sulfate-free, so it won't strip your hair too much. It's also got some nice oils in it to help keep your hair from getting too dry.",
      "asin": "B0089NVH5W",
      "ingredients_raw": "aqua water eau, cocamidopropyl hydroxysultaine, disodium laureth sulfosuccinate, sodium lauryl sulfoacetate, sodium lauroyl sarcosinate, sodium polystyrene sulfonate, sodium chloride, cocamidopropylamine oxide, argania spinosa argan kernel oil, persea gratissima avocado oil, rosmarinus officinalis rosemary leaf extract, chamomilla recutita matricaria flower extract, lavandula angustifolia lavender flower extract, simmondsia chinensis jojoba seed extract, keratin amino acids, hydrolyzed keratin, silk amino acids, panthenol, sodium pca, cinnamidopropyltrimonium chloride, butylene glycol, peg-40 hydrogenated castor oil, peg-150 pentaerythrityl tetrastearate, peg-6 caprylic capric glycerides, caprylyl glycol, tetrasodium edta, disodium edta, chlorphenesin, phenoxyethanol, parfum fragrance, ci 17200 red 33, ci 19140 yellow 5, sodium hydroxide, citric acid, alpha-isomethyl ionone, butylphenyl methylpropional, linalool, hydroxyisohexyl 3-cyclohexene carboxaldehydethylpropional",
      "cost": 3.8,
      "id": "clarifying_shampoo",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 4,
          "film_forming_humectants_number": 3,
          "emollients_number": 3,
          "simple_humectants": [
            "Panthenol",
            "Sodium PCA",
            "Butylene glycol",
            "Caprylyl Glycol"
          ],
          "film_forming_humectants": [
            "Keratin",
            "Hydrolyzed keratin",
            "Silk Amino Acids"
          ],
          "emollients": [
            "Unknown Oil",
            "Avocado Oil",
            "Castor Oil"
          ],
          "score": -68
        },
        "porosity": {
          "high": 50,
          "low": 100
        }
      },
      "cost_rating": "5"
    },
    "wash_&_scrub_detox_shampoo": {
      "name": "Wash & Scrub Detox Shampoo",
      "brand": "Curlsmith",
      "product_categories": [
        "clarifying_shampoos"
      ],
      "ingredients_raw": "water aqua, perlite, sodium methyl cocoyl taurate plant derived, cocamidopropyl betaine plant derived, decyl glucoside, lactobacillus ferment lysate, leuconostoc radish root ferment filtrate, hylocereus undatus dragon fruit fruit extract, paullinia cupana guarana seed extract, urtica dioica nettle leaf extract, zingiber officinale ginger root extract, malva sylvestris mallow flower extract, acetic acid vinegar, acrylates c10-30 alkyl acrylate crosspolymer, guar hydroxypropyltrimonium chloride, polyquaternium-10, glycerin, citric acid, potassium sorbate, sodium hydroxide, phenoxyethanol, sodium benzoate, linalool, limonene, fragrance parfum",
      "tags": [
        "low_porosity",
        "normal_porosity",
        "featured"
      ],
      "buy_links": [
        {
          "url": "https://amzn.to/4iUapKl",
          "retailer": "Amazon",
          "country": "UK"
        },
        {
          "url": "https://amzn.to/4g18iBT",
          "retailer": "Amazon",
          "country": "US"
        },
        {
          "url": "https://go.skimresources.com?id=276362X1762442&xs=1&url=https%3A%2F%2Fcurlsmith.com%2Fproducts%2Fwash-scrub-detox-pro-biotic",
          "retailer": "Curlsmith"
        },
        {
          "url": "https://go.skimresources.com?id=276362X1762442&xs=1&url=https%3A%2F%2Fuk.curlsmith.com%2Fproducts%2Fwash-scrub-detox-pro-biotic",
          "retailer": "Curlsmith",
          "country": "UK"
        }
      ],
      "asin": "B08636L8JY",
      "cost": 2.6,
      "id": "wash_&_scrub_detox_shampoo",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 1,
          "film_forming_humectants_number": 0,
          "emollients_number": 2,
          "simple_humectants": [
            "Glycerin"
          ],
          "film_forming_humectants": [],
          "emollients": [
            "Guar Hydroxypropyltrimonium Chloride",
            "Unknown Polyquat"
          ],
          "score": -48
        },
        "porosity": {
          "high": 100,
          "low": 100
        }
      },
      "cost_rating": "5"
    },
    "water_works_clarifying_shampoo": {
      "name": "Water Works Clarifying Shampoo",
      "brand": "Ouidad",
      "product_categories": [
        "clarifying_shampoos"
      ],
      "tags": [
        "low_porosity",
        "normal_porosity",
        "featured"
      ],
      "buy_links": [
        {
          "url": "https://click.linksynergy.com/link?id=9QcV0uNyab0&offerid=929395.3842991208&type=2&murl=https%3a%2f%2fwww.ouidad.com%2fproducts%2fwater-works-clarifying-shampoo%3fvariant%3d42617153618178",
          "retailer": "Ouidad"
        }
      ],
      "cost": 2.8,
      "asin": "B0001Y74XG",
      "ingredients_raw": "water, ammonium laureth sulfate, sodium laureth sulfate, cocomidopropyl betaine, lauryl glucoside, butylene glycol, cocamide mea, polysorbate 20, sodium lauroamphoacetate, panthenol, saccharum officinarum sugar cane extract, citrus medica limonum lemon peel extract, citrus aurantium dulcis orange fruit extract, pyrus malus apple fruit extract, camellia oleifera leaf extract, cetrimonium chloride, polyquaternium-59, polyquaternium-10, citrus aurantium dulcis orange peel oil, citrus tangerina tangerine peel oil, disodium edta, methychloroisothiazolinone, methylisothiazolinone",
      "description": "This clarifying shampoo contains sulfates, making it ideal for occasional use to remove product buildup, especially for those with low-porosity hair. While effective, it may be drying. To minimize this, focus application on the scalp and consider adding conditioner to the ends.",
      "id": "water_works_clarifying_shampoo",
      "systems_excluded": [],
      "status": "warning",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 0,
          "emollients_number": 5,
          "simple_humectants": [
            "Butylene glycol",
            "Panthenol"
          ],
          "film_forming_humectants": [],
          "emollients": [
            "Cetrimonium Chloride",
            "Unknown Polyquat",
            "Unknown Polyquat",
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -29
        },
        "porosity": {
          "high": 100,
          "low": 100
        }
      },
      "cost_rating": "5"
    },
    "gentle_clarifying_shampoo": {
      "name": "Gentle Clarifying Shampoo",
      "brand": "Bounce Curl",
      "product_categories": [
        "clarifying_shampoos"
      ],
      "tags": [
        "low_porosity",
        "normal_porosity",
        "high_porosity"
      ],
      "ingredients_raw": "water, sodium lauroyl methyl isethionate, decyl glucoside, sodium cocoyl isethionate, disodium cocoamphodiacetate, propanediol, panthenol pro-vitamin b5, polyquaternium-10, hydroxypropyl methylcellulose, biotin, vanillin, hydrolyzed adansonia digitata baobab seed protein, nigella sativa virgin black cumin oil, stearamidopropyl dimethylamine, lactic acid, caprylhydroxamic acid, rosmarinus officinalis rosemary leaf extract, boswellia carterii oil, lactobacillus punica granatum fruit ferment extract, lactobacillus pumpkin ferment extract, argania spinosa kernel oil, cocos nucifera coconut oil, citrus aurantium bergamia bergamot fruit oil, anthemis nobilis flower oil, geranium maculatum oil, citrus paradisi grapefruit seed oil, lavandula angustifolia lavender oil, pogostemon cablin oil, citrus aurantium dulcis orange seed oil, citrus nobilis mandarin orange peel oil, caprylyl glycol",
      "buy_links": [
        {
          "url": "https://glnk.io/x26q/curlsbot258",
          "retailer": "Bounce Curl"
        }
      ],
      "id": "gentle_clarifying_shampoo",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 4,
          "film_forming_humectants_number": 1,
          "emollients_number": 14,
          "simple_humectants": [
            "Propanediol",
            "Panthenol",
            "Lactic Acid",
            "Caprylyl Glycol"
          ],
          "film_forming_humectants": [
            "Unknown Protein"
          ],
          "emollients": [
            "Unknown Polyquat",
            "Unknown Oil",
            "Stearamidopropyl Dimethylamine",
            "Unknown Oil",
            "Argan Oil",
            "Coconut Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Lavender Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -53
        },
        "porosity": {
          "high": 100,
          "low": 0
        }
      }
    },
    "natural_detox_hair_mask": {
      "name": "Natural Detox Hair Mask",
      "brand": "Innersense",
      "product_categories": [
        "clarifying_shampoos"
      ],
      "tags": [
        "low_porosity",
        "normal_porosity",
        "high_porosity",
        "featured"
      ],
      "ingredients_raw": "water aqua eau, cetearyl alcohol, kaolin, glycerin, vinegar, charcoal powder, oryza sativa rice bran oil, behentrimonium methosulfate, olea europaea olive fruit extract, butyrospermum parkii shea butter, stearalkonium chloride, hydrolyzed quinoa, epilobium angustifolium flower leaf stem extract, panthenol vitamin b-5, potassium sorbate, hydrolyzed adansonia digitata seed extract, sodium levulinate, stearyl alcohol, thiamine hcl, benzyl alcohol, sodium benzoate, glycine soja soybean oil, cananga odorata ylang ylang flower oil, citrus aurantium dulcis orange peel oil, lavandula angustifolia lavender oil, pogostemon cablin patchouli oil, salvia sclarea clary oil, linalool, limonene",
      "buy_links": [
        {
          "url": "https://amzn.to/4gTtFWm",
          "retailer": "Amazon"
        },
        {
          "url": "https://go.skimresources.com?id=276362X1762442&xs=1&url=https%3A%2F%2Fwww.ulta.com%2Fp%2Fdetox-hair-mask-treatment-pimprod2032274%3Fsku%3D2594263",
          "retailer": "Ulta"
        }
      ],
      "cost": 5,
      "asin": "B09YS5YRTR",
      "description": "This mask is a great gentle option for removing stubborn buildup without stripping out your natural oils.",
      "id": "natural_detox_hair_mask",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 0,
          "emollients_number": 12,
          "simple_humectants": [
            "Glycerin",
            "Panthenol"
          ],
          "film_forming_humectants": [],
          "emollients": [
            "Cetearyl Alcohol",
            "Rice bran oil",
            "Behentrimonium Methosulfate",
            "Butyrospermum Parkii Shea Butter",
            "Stearyl Alcohol",
            "Benzyl Alcohol",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Lavender Oil",
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -59
        },
        "porosity": {
          "high": 92,
          "low": 0
        }
      },
      "cost_rating": "5"
    },
    "scalp_care_clarifying_shampoo": {
      "name": "Scalp Care Clarifying Shampoo",
      "brand": "Maui Moisture",
      "cost": 0.61,
      "buy_links": [
        {
          "url": "https://amzn.to/4gV7M9j",
          "retailer": "Amazon"
        },
        {
          "url": "https://go.skimresources.com?id=276362X1762442&xs=1&url=https%3A%2F%2Fwww.cvs.com%2Fshop%2Fmaui-moisture-scalp-care-clarifying-shampoo-13-oz-prodid-916853",
          "retailer": "CVS"
        }
      ],
      "asin": "B0CLBZ5PBS",
      "ingredients_raw": "aloe barbadensis leaf juice, water aqua, sodium c14-16 olefin sulfonate, cocamidopropyl betaine, coco-glucoside, citric acid, glycol distearate, vinegar, tocopheryl acetate, cocos nucifera coconut water, nigella sativa seed oil, opuntia ficus-indica seed oil, adansonia digitata seed oil, cocos nucifera coconut seed butter, butyrospermum parkii shea butter, calophyllum inophyllum seed oil, moringa oleifera seed oil, tetraselmis suecica extract, hydroxyphenyl propamidobenzoic acid, peg-5 ethylhexanoate, trideceth-9, mannitol, polyquaternium-10, acrylates crosspolymer-4, laureth-4, glycerin, guar hydroxypropyltrimonium chloride, peg-150 pentaerythrityl tetrastearate, ppg-2 hydroxyethyl cocamide, hexylene glycol, sodium citrate, sodium hydroxide, sodium benzoate, fragrance parfum",
      "product_categories": [
        "clarifying_shampoos"
      ],
      "tags": [
        "low_porosity",
        "normal_porosity",
        "high_porosity"
      ],
      "id": "scalp_care_clarifying_shampoo",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 1,
          "emollients_number": 8,
          "simple_humectants": [
            "Glycerin",
            "Hexylene Glycol"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [
            "Unknown Oil",
            "Unknown Oil",
            "Baobab Oil",
            "Butyrospermum Parkii Shea Butter",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Polyquat",
            "Guar Hydroxypropyltrimonium Chloride"
          ],
          "score": -88
        },
        "porosity": {
          "high": 89,
          "low": 31
        }
      },
      "cost_rating": "1"
    },
    "vitalcurl+_balancing_rinse_conditioner_": {
      "name": "VitalCurl+ Balancing Rinse Conditioner ",
      "brand": "Ouidad",
      "ingredients_raw": "aqua water eau, cetearyl alcohol, cetyl alcohol, glycerin, stearyl alcohol, hydrolyzed wheat protein, helianthus annuus sunflower seed oil, olea europaea olive fruit oil, camellia japonica tsubaki seed oil, salvia hispanica chia seed oil, glycine soja soybean oil, canola canola oil huile de colza, glycine soja soybean sterols, glycolipids, tocopheryl acetate, glyceryl stearate, cetearyl ethylhexanoate, cetrimonium chloride, polyquaternium-59, hydroxyethylcellulose, phospholipids, lactic acid, isopropyl myristate, butylene glycol, benzophenone-4, disodium edta, bht, sodium hydroxide, hexylene glycol, caprylyl glycol, phenoxyethanol, hexyl cinnamal, limonene, linalool, parfum fragrance",
      "product_categories": [
        "conditioners"
      ],
      "tags": [
        "normal_porosity"
      ],
      "buy_links": [
        {
          "url": "https://click.linksynergy.com/link?id=9QcV0uNyab0&offerid=929395.3842998208&type=2&murl=https%3a%2f%2fwww.ouidad.com%2fproducts%2fvitalcurl-plus-balancing-rinse-conditioner%3fvariant%3d42433997242626",
          "retailer": "Ouidad"
        }
      ],
      "cost": 1.5,
      "id": "vitalcurl+_balancing_rinse_conditioner_",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 5,
          "film_forming_humectants_number": 3,
          "emollients_number": 11,
          "simple_humectants": [
            "Glycerin",
            "Lactic Acid",
            "Butylene glycol",
            "Hexylene Glycol",
            "Caprylyl Glycol"
          ],
          "film_forming_humectants": [
            "Hydrolyzed Wheat Protein",
            "Glycine",
            "Hydroxyethylcellulose"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Cetyl Alcohol",
            "Stearyl Alcohol",
            "Sunflower Oil",
            "Olive Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Cetrimonium Chloride",
            "Unknown Polyquat"
          ],
          "score": -70
        },
        "porosity": {
          "high": 96,
          "low": 0
        }
      },
      "cost_rating": "2"
    },
    "light_conditioner": {
      "name": "Light Conditioner",
      "brand": "MopTop",
      "buy_links": [
        {
          "url": "https://amzn.to/2ApLXiq",
          "retailer": "Amazon"
        }
      ],
      "product_categories": [
        "conditioners"
      ],
      "tags": [],
      "cost": 2.12,
      "ingredients_raw": "water, glycerin, cetyl alcohol coconut derived, stearyl alcohol coconut derived, olea europaea olive fruit oil, cetrimonium chloride, behentrimonium chloride, aloe barbadensis leaf extract, glycereth-26, hypnea musciformis extract seaweed, gelidiella acerosa extract seaweed, sargassum filipendula extract seaweed, sorbitol, hydroxypropyltrimonium honey, silk amino acids, rosmarinus officinalis rosemary leaf extract, chamomilla recutita matricaria flower extract, urtica dioica nettle extract, butyrospermum parkii shea butter, simmondsia chinensis jojoba seed oil, tocopheryl acetate vitamin e, panthenol vitamin b5, citrus senensis oil, citrus limon oil, citrus arantifolia oil, citrus paradisi oil, sodium phytate, hydroxyethylcellulose, phenoxyethanol, ethylhexylglycerin, citric acid",
      "asin": "B005SIR28M",
      "id": "light_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 5,
          "film_forming_humectants_number": 7,
          "emollients_number": 11,
          "simple_humectants": [
            "Glycerin",
            "Glycereth-26",
            "Sorbitol",
            "Panthenol",
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Seaweed Extract",
            "Seaweed Extract",
            "Seaweed Extract",
            "Hydroxypropyltrimonium Honey",
            "Silk Amino Acids",
            "Hydroxyethylcellulose"
          ],
          "emollients": [
            "Cetyl Alcohol",
            "Stearyl Alcohol",
            "Olive Oil",
            "Cetrimonium Chloride",
            "Behentrimonium Chloride",
            "Butyrospermum Parkii Shea Butter",
            "Jojoba Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -69
        },
        "porosity": {
          "high": 100,
          "low": 19
        }
      },
      "cost_rating": "4"
    },
    "daily_conditioner": {
      "name": "Daily Conditioner",
      "brand": "MopTop",
      "buy_links": [
        {
          "url": "https://amzn.to/3ZS5qAW",
          "retailer": "Amazon"
        }
      ],
      "product_categories": [
        "conditioners"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity"
      ],
      "ingredients_raw": "water, aloe barbadensis leaf extract, glycerin, cetyl alcohol, stearyl alcohol, cetrimonium chloride, behentrimonium chloride, olea europaea olive fruit oil, glycereth-26, butyrospermum parkii shea butter, hydroxypropyltrimonium honey, hypnea musciformis extract seaweed, gelidiella acerosa extract seaweed, sargassum filipendula extract seaweed, sorbitol, silk amino acids, rosmarinus officinalis rosemary leaf extract, chamomilla recutita matricaria flower extract, urtica dioica nettle extract, simmondsia chinensis jojoba seed oil, tocopheryl acetate vitamin e, panthenol vitamin b5, arnica montana flower extract, hydroxyethylcellulose, phenoxyethanol, sorbic acid, ethylhexylglycerin, citric acid, sodium phytate, fragrance",
      "cost": 2.12,
      "asin": "B005SIR2K0",
      "id": "daily_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 5,
          "film_forming_humectants_number": 7,
          "emollients_number": 7,
          "simple_humectants": [
            "Glycerin",
            "Glycereth-26",
            "Sorbitol",
            "Panthenol",
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Hydroxypropyltrimonium Honey",
            "Seaweed Extract",
            "Seaweed Extract",
            "Seaweed Extract",
            "Silk Amino Acids",
            "Hydroxyethylcellulose"
          ],
          "emollients": [
            "Cetyl Alcohol",
            "Stearyl Alcohol",
            "Cetrimonium Chloride",
            "Behentrimonium Chloride",
            "Olive Oil",
            "Butyrospermum Parkii Shea Butter",
            "Jojoba Oil"
          ],
          "score": -76
        },
        "porosity": {
          "high": 100,
          "low": 55
        }
      },
      "cost_rating": "4"
    },
    "pure_inspiration_daily_conditioner": {
      "name": "Pure Inspiration Daily Conditioner",
      "brand": "Innersense",
      "ingredients_raw": "water aqua eau, cetearyl alcohol, glycerin, aloe barbadensis leaf juice, caprylic capric triglyceride, behentrimonium methosulfate, gluconolactone, stearalkonium chloride, oryza sativa rice extract, sodium benzoate, potassium sorbate, cetyl hydroxyethylcellulose, cocos nucifera coconut oil, oryza sativa rice bran oil, persea gratissima avocado oil, butyrospermum parkii shea butter, hydrolyzed quinoa, hydrolyzed rice protein, citric acid, citrus aurantium dulcis orange peel oil, camellia sinensis leaf extract, cucumis sativus cucumber fruit extract, mangifera indica mango fruit extract, persea gratissima avocado fruit extract, stearyl alcohol, amine hcl, calcium gluconate, benzyl alcohol, benzyl salicylate, citronellol, hexyl cinnamal, limonene, linalool",
      "product_categories": [
        "conditioners"
      ],
      "tags": [
        "normal_porosity"
      ],
      "buy_links": [
        {
          "url": "https://amzn.to/3ZQnjjL",
          "retailer": "Amazon"
        },
        {
          "url": "https://go.skimresources.com?id=276362X1762442&xs=1&url=https%3A%2F%2Fshop.beauty-heroes.com%2Fproducts%2Fpure-inspiration-conditioner-innersense-organic-beauty",
          "retailer": "Beauty Heroes"
        }
      ],
      "cost": 3,
      "asin": "B074Q43PT4",
      "id": "pure_inspiration_daily_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 1,
          "film_forming_humectants_number": 3,
          "emollients_number": 9,
          "simple_humectants": [
            "Glycerin"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Hydroxyethylcellulose",
            "Unknown Protein"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Behentrimonium Methosulfate",
            "Coconut Oil",
            "Rice bran oil",
            "Avocado Oil",
            "Butyrospermum Parkii Shea Butter",
            "Unknown Oil",
            "Stearyl Alcohol",
            "Benzyl Alcohol"
          ],
          "score": -75
        },
        "porosity": {
          "high": 100,
          "low": 7
        }
      },
      "cost_rating": "5"
    },
    "hydrating_cream_conditioner": {
      "name": "Hydrating Cream Conditioner",
      "brand": "Innersense",
      "ingredients_raw": "water aqua-eau, cetearyl alcohol, glycerin, behentrimonium methosulfate, aloe barbadensis aloe vera leaf gel, stearalkonium chloride, diheptyl succinate, capryloyl glycerin, cocos nucifera, cananga odorata flower oil, lavandula angustifolia lavender oil, citrus aurantium dulcis orange peel oil, salvia sclarea clary oil, vanillin, pogostemon cablin oil, glycine soja soybean oil, cocos nucifera coconut oil, sodium benzoate, oryza sativa rice extract, theobroma cacao cocoa seed butter, potassium sorbate, guar hydroxypropyltrimonium chloride, citric acid, cetyl hydroxyethylcellulose, linum usitatissimum linseed seed oil, calophyllum inophyllum tamanu oil, hydrolyzed rice protein, plumeria actufolia flower extract, persea gratissima avocado oil, butyrospermum parkii shea butter, simmondsia chinensis jojoba seed oil, hydrolyzed quinoa, benzyl alcohol, taraxacum officinale dandelion leaf extract, salvia officinalis sage leaf extract, melissa officinalis leaf extract, linalool, limonene",
      "product_categories": [
        "conditioners"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity"
      ],
      "buy_links": [
        {
          "url": "https://amzn.to/4gmVZAG",
          "retailer": "Amazon"
        }
      ],
      "cost": 3,
      "asin": "B074PWBRF9",
      "id": "hydrating_cream_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 3,
          "emollients_number": 17,
          "simple_humectants": [
            "Glycerin",
            "Glycerin"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Hydroxyethylcellulose",
            "Unknown Protein"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Behentrimonium Methosulfate",
            "Diheptyl Succinate",
            "Unknown Oil",
            "Lavender Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Coconut Oil",
            "Guar Hydroxypropyltrimonium Chloride",
            "Unknown Oil",
            "Unknown Oil",
            "Avocado Oil",
            "Butyrospermum Parkii Shea Butter",
            "Jojoba Oil",
            "Benzyl Alcohol"
          ],
          "score": -69
        },
        "porosity": {
          "high": 100,
          "low": 0
        }
      },
      "cost_rating": "5"
    },
    "clarity_conditioner": {
      "name": "Clarity Conditioner",
      "brand": "Innersense",
      "ingredients_raw": "water aqua eau, aloe barbadensis leaf juice, cetearyl alcohol, glycerin, behentrimonium methosulfate, stearalkonium chloride, butyrospermum parkii shea butter, honey, citric acid, sodium levulinate, potassium sorbate, cocos nucifera coconut oil, prunus armeniaca apricot kernel oil, colloidal oatmeal, guar hydroxypropyltrimonium chloride, sodium gluconate, tocopherol, vaccinium macrocarpon cranberry seed oil, swertia japonica extract, stearyl alcohol, thiamine hcl, leuconostoc radish root ferment filtrate",
      "product_categories": [
        "conditioners"
      ],
      "tags": [
        "normal_porosity"
      ],
      "buy_links": [
        {
          "url": "https://amzn.to/4iNhH2s",
          "retailer": "Amazon"
        }
      ],
      "cost": 3,
      "asin": "B0BHC6CTQ5",
      "id": "clarity_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 1,
          "emollients_number": 8,
          "simple_humectants": [
            "Glycerin",
            "Honey"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Behentrimonium Methosulfate",
            "Butyrospermum Parkii Shea Butter",
            "Coconut Oil",
            "Apricot Kernel Oil",
            "Guar Hydroxypropyltrimonium Chloride",
            "Unknown Oil",
            "Stearyl Alcohol"
          ],
          "score": -72
        },
        "porosity": {
          "high": 100,
          "low": 0
        }
      },
      "cost_rating": "5"
    },
    "drench_&_quench_rich_conditioner": {
      "name": "Drench & Quench Rich Conditioner",
      "brand": "Lohy",
      "product_categories": [
        "conditioners",
        "deep_conditioners"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity"
      ],
      "ingredients_raw": "aqua, aloe barbadensis aloe vera leaf juice, cetearyl alcohol, behentrimonium methosulfate, glycerin, propanediol, cocos nucifera coconut oil, cetrimonium chloride, phenoxyethanol, butyrospermum parkii shea butter, hydrolised soy protein, simmondsia chinensis jojoba seed oil, chamomila recutita matricaria flower leaf stem extract, camellia sinensis white tea leaf extract, guar hydroxypropyltrimonium chloride, polyquaternium-10, sodium benzoate, citrus aurantifolia lime oil, cymbopogan flexuosus lemongrass oil, sodium pca, sodium lactate, arginine, aspartic acid, pca, glycine, alanine, serine, valine, proline, threonine, isoleucine, histidine, phenylalanine",
      "buy_links": [
        {
          "url": "https://lohy.com.au/products/drench-quench-curl-moisture-mask?aff=49",
          "retailer": "Lohy",
          "country": "AU"
        }
      ],
      "cost": 3.4,
      "id": "drench_&_quench_rich_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 5,
          "film_forming_humectants_number": 10,
          "emollients_number": 10,
          "simple_humectants": [
            "Glycerin",
            "Propanediol",
            "Sodium PCA",
            "Sodium Lactate",
            "PCA"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Unknown Protein",
            "Arginine",
            "Aspartic Acid",
            "Glycine",
            "Alanine",
            "Serine",
            "Proline",
            "Histidine",
            "Phenylalanine"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Behentrimonium Methosulfate",
            "Coconut Oil",
            "Cetrimonium Chloride",
            "Butyrospermum Parkii Shea Butter",
            "Jojoba Oil",
            "Guar Hydroxypropyltrimonium Chloride",
            "Unknown Polyquat",
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -77
        },
        "porosity": {
          "high": 100,
          "low": 7
        }
      },
      "cost_rating": "5"
    },
    "nourish_&_flourish_conditioner": {
      "name": "Nourish & Flourish Conditioner",
      "brand": "Lohy",
      "product_categories": [
        "conditioners"
      ],
      "tags": [
        "normal_porosity"
      ],
      "buy_links": [
        {
          "url": "https://lohy.com.au/products/nourish-flourish-conditioner-curly-hair?aff=49",
          "retailer": "Lohy",
          "country": "AU"
        }
      ],
      "ingredients_raw": "aqua, cetearyl alcohol, glycerin, propanediol, cocos nucifera coconut oil, cetrimonium chloride, hydrolysed soy protein, phenoxyethanol, simmondsia chinensis jojoba seed oil, chamomila recutita matricaria flower leaf stem extract, cucumis sativus cucumber fruit extract, benzyl alcohol, guar hydroxypropyltrimonium chloride, lemon scented tea tree oil, mandarin peel oil, rosemary oil, may chang, eucalyptus radiata, lavandin oil, salvia clary sclarea oil, pogostemon cablin patchouli oil, citric acid, dehydroacetic acid",
      "cost": 2.3,
      "id": "nourish_&_flourish_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 1,
          "emollients_number": 12,
          "simple_humectants": [
            "Glycerin",
            "Propanediol"
          ],
          "film_forming_humectants": [
            "Unknown Protein"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Coconut Oil",
            "Cetrimonium Chloride",
            "Jojoba Oil",
            "Benzyl Alcohol",
            "Guar Hydroxypropyltrimonium Chloride",
            "Tea Tree Oil",
            "Unknown Oil",
            "Rosemary Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -60
        },
        "porosity": {
          "high": 100,
          "low": 0
        }
      },
      "cost_rating": "4"
    },
    "essential_moisture_conditioner": {
      "name": "Essential Moisture Conditioner",
      "brand": "Curlsmith",
      "product_categories": [
        "conditioners"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity"
      ],
      "ingredients_raw": "water aqua, cetearyl alcohol, hydroxypropyl starch phosphate, betaine, cetyl palmitate, behentrimonium chloride, butyrospermum parkii shea butter, cocos nucifera coconut oil, persea gratissima avocado oil, helianthus annuus sunflower seed oil, aloe barbadensis leaf juice, selaginella lepidophylla resurrection flower extract, ocimum basilicum basil leaf extract, piper nigrum black pepper seed extract, rosmarinus officinalis rosemary leaf extract, salvia officinalis sage leaf extract, carapa guaianensis andiroba seed oil, glycerin, guar hydroxypropyltrimonium chloride, panthenol, glyceryl undecylenate, fragrance parfum, citric acid, sodium hydroxide, sodium gluconate, glyceryl caprylate, potassium sorbate, sodium benzoate, limonene, linalool, isopropyl alcohol",
      "buy_links": [
        {
          "url": "https://amzn.to/3BDw34T",
          "retailer": "Amazon",
          "country": "UK"
        },
        {
          "url": "https://amzn.to/3Q3TZC5",
          "retailer": "Amazon"
        }
      ],
      "asin": "B0BPTBMJY4",
      "cost": 1.6,
      "description": "This has a small amount of isopropyl alcohol, which we mark as caution, but as it's last on the ingredients list and this is a product meant to be washed out, it's unlikely to be harmful for hair.",
      "id": "essential_moisture_conditioner",
      "systems_excluded": [],
      "status": "caution",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 1,
          "emollients_number": 8,
          "simple_humectants": [
            "Glycerin",
            "Panthenol"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Behentrimonium Chloride",
            "Butyrospermum Parkii Shea Butter",
            "Coconut Oil",
            "Avocado Oil",
            "Sunflower Oil",
            "Unknown Oil",
            "Guar Hydroxypropyltrimonium Chloride"
          ],
          "score": -74
        },
        "porosity": {
          "high": 100,
          "low": 0
        }
      },
      "cost_rating": "3"
    },
    "tea_tree_triple_treat_invigorating_conditioner": {
      "name": "Tea Tree Triple Treat Invigorating Conditioner",
      "brand": "Giovanni",
      "tags": [
        "normal_porosity"
      ],
      "product_categories": [
        "conditioners"
      ],
      "cost": 1,
      "buy_links": [
        {
          "url": "https://amzn.to/4j88bqW",
          "retailer": "Amazon"
        }
      ],
      "ingredients_raw": "aqua purified water, cetyl alcohol, stearyl alcohol, glycerin, panthenol, cetrimonium chloride, cetearyl alcohol, hydroxypropyl guar, behentrimonium methosulfate, menthol, polysorbate 60, citric acid, ethylhexylglycerin, phenoxyethanol, mentha piperita peppermint oil, aloe barbadensis aloe vera leaf juice, carthamus tinctorius safflower oil, achillea millefolium extract, chamomilla recutita matricaria flower extract, equisetum arvense extract, eucalyptus globulus eucalyptus oil, lavandula angustifolia lavender leaf extract, melaleuca alternifolia tea tree leaf oil, rosmarinus officinalis rosemary leaf extract, salvia officinalis sage leaf extract, thymus vulgaris thyme extract, tussilago farfara coltsfoot flower extract, urtica dioica nettle extract, usda certified organic",
      "id": "tea_tree_triple_treat_invigorating_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 1,
          "emollients_number": 10,
          "simple_humectants": [
            "Glycerin",
            "Panthenol",
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [
            "Cetyl Alcohol",
            "Stearyl Alcohol",
            "Cetrimonium Chloride",
            "Cetearyl Alcohol",
            "Guar Hydroxypropyltrimonium Chloride",
            "Behentrimonium Methosulfate",
            "Peppermint Oil",
            "Safflower Oil",
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -58
        },
        "porosity": {
          "high": 100,
          "low": 62
        }
      },
      "cost_rating": "1"
    },
    "behentrimonium_chloride_2%_conditioner": {
      "name": "Behentrimonium Chloride 2% Conditioner",
      "brand": "The Ordinary",
      "product_categories": [
        "conditioners"
      ],
      "tags": [
        "normal_porosity",
        "low_porosity"
      ],
      "cost": 1.3,
      "ingredients_raw": "aqua water, cetearyl alcohol, behentrimonium chloride, cyamopsis tetragonoloba guar gum, phytic acid, phenoxyethanol, chlorphenesin",
      "description": "With only 7 ingredients and no oils, this conditioner is ideal for those with low porosity hair.",
      "buy_links": [
        {
          "url": "https://amzn.to/40IHa63",
          "retailer": "Amazon"
        },
        {
          "url": "https://fave.co/3PNA3D2",
          "retailer": "The Ordinary"
        }
      ],
      "id": "behentrimonium_chloride_2%_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 0,
          "film_forming_humectants_number": 0,
          "emollients_number": 3,
          "simple_humectants": [],
          "film_forming_humectants": [],
          "emollients": [
            "Cetearyl Alcohol",
            "Behentrimonium Chloride",
            "Guar Gum"
          ],
          "score": -76
        },
        "porosity": {
          "high": 100,
          "low": 100
        }
      },
      "cost_rating": "2"
    },
    "tropical_coconut_conditioner": {
      "name": "Tropical Coconut Conditioner",
      "brand": "Suave",
      "product_categories": [
        "conditioners"
      ],
      "tags": [
        "normal_porosity",
        "low_porosity"
      ],
      "cost": 0.09,
      "buy_links": [
        {
          "url": "https://go.skimresources.com?id=276362X1762442&xs=1&url=https%3A%2F%2Fwww.walmart.com%2Fip%2FSuave-Essentials-Nourishing-Conditioner-Tropical-Coconut-22-5-fl-oz%2F943974558",
          "retailer": "Walmart"
        }
      ],
      "ingredients_raw": "water aqua, cetyl alcohol, stearamidopropyl dimethylamine, lactic acid, potassium chloride, fragrance parfum, disodium edta, peg-150 distearate, 2-bromo-2-nitropropane-1, 3-diol, methylchloroisothiazolinone, methylisothiazolinone, propylene glycol, tocopheryl acetate vitamin e acetate, silk amino acids, honey, urtica dioica nettle extract, rosmarinus officinalis rosemary leaf extract, cocos nucifera coconut fruit extract",
      "id": "tropical_coconut_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 1,
          "emollients_number": 2,
          "simple_humectants": [
            "Lactic Acid",
            "Propylene Glycol",
            "Honey"
          ],
          "film_forming_humectants": [
            "Silk Amino Acids"
          ],
          "emollients": [
            "Cetyl Alcohol",
            "Stearamidopropyl Dimethylamine"
          ],
          "score": -51
        },
        "porosity": {
          "high": 100,
          "low": 92
        }
      },
      "cost_rating": "1"
    },
    "cream_conditioner": {
      "name": "Cream Conditioner",
      "brand": "Curl Keeper",
      "product_categories": [
        "conditioners"
      ],
      "tags": [
        "featured"
      ],
      "cost": 3,
      "ingredients_raw": "water aqua eau, isopropyl myristate, cetearyl alcohol, simmondsia chinensis jojoba seed oil, cetrimonium chloride, ceteareth-33, panthenol, silk amino acids, wheat amino acids, parfum, sodium levulinate, potassium sorbate, lecithin, citric acid, sodium chloride, benzoic acid, benzyl alcohol, benzyl benzoate, phenoxyethanol, citral, citronellol, coumarin, eugenol, geraniol, limonene, linalool",
      "buy_links": [
        {
          "url": "https://curlkeeper.com/r?id=6qjs4u",
          "retailer": "Curl Keeper"
        }
      ],
      "id": "cream_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 2,
          "emollients_number": 4,
          "simple_humectants": [
            "Panthenol",
            "Lecithin"
          ],
          "film_forming_humectants": [
            "Silk Amino Acids",
            "Wheat Amino Acids"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Jojoba Oil",
            "Cetrimonium Chloride",
            "Benzyl Alcohol"
          ],
          "score": -73
        },
        "porosity": {
          "high": 97,
          "low": 83
        }
      },
      "cost_rating": "5"
    },
    "big_energy_conditioner": {
      "name": "Big Energy Conditioner",
      "brand": "Curl Keeper",
      "product_categories": [
        "conditioners"
      ],
      "tags": [
        "featured"
      ],
      "cost": 2.8,
      "ingredients_raw": "water aqua eau, cetyl alcohol, cetearyl alcohol, behentrimonium chloride, glycerin, propanediol, stearamido-propyl dimethylamine, isopropyl myristate, cocos nucifera coconut water, aloe barbadensis leaf juice, chamomilla recutita matricaria flower extract, lavandula angustifolia lavender extract, cetyl esters, cetrimonium chloride, guar hydroxypropyltrimonium chloride, dicetyldimonium chloride, propylene glycol, caprylyl glycol, 1, 2-hexanediol, leuconostoc radish root ferment filtrate, fragrance parfum, potassiu, sorbate, panthenol, to-copheryl acetate, sodium benzoate, edta, citric acid, isopropyl alcohol, phenoxyethanol, ethylhexylglycerin, amyl cinnamal, limonene, isoeugenol, linalool",
      "buy_links": [
        {
          "url": "https://curlkeeper.com/r?id=ms7prl",
          "retailer": "Curl Keeper"
        }
      ],
      "id": "big_energy_conditioner",
      "systems_excluded": [],
      "status": "caution",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 6,
          "film_forming_humectants_number": 1,
          "emollients_number": 5,
          "simple_humectants": [
            "Glycerin",
            "Propanediol",
            "Propylene Glycol",
            "Caprylyl Glycol",
            "Panthenol",
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [
            "Cetyl Alcohol",
            "Cetearyl Alcohol",
            "Behentrimonium Chloride",
            "Cetrimonium Chloride",
            "Guar Hydroxypropyltrimonium Chloride"
          ],
          "score": -51
        },
        "porosity": {
          "high": 100,
          "low": 87
        }
      },
      "cost_rating": "5"
    },
    "super_smooth_cream_conditioner": {
      "name": "Super Smooth Cream Conditioner",
      "brand": "Bounce Curl",
      "product_categories": [
        "conditioners"
      ],
      "tags": [
        "featured"
      ],
      "cost": 2.8,
      "ingredients_raw": "organic aloe barbadensis leaf juice, behentrimonium methosulfate, cetearyl alcohol, hybrid safflower oil, glycerin, stearamidopropyl dimethylamine, propanediol, panthenol pro-vitamin b5, polyquternium-10, nigella sativa virgin black cumin oil, tocopheryl acetate vitamin e, citrus nobilis mandarin orange peel oil, vanillin, lactic acid, caprylhydroxamic acid, anthemis nobilis chamomile flower extract, althaea officinalis marshmallow root extract, geranium maculatum oil, camellia sinensis green tea leaf extract, rosmarinus officinalis rosemary leaf extract, brassica oleracea italica broccoli seed oil, urtica dioica nettle extract, salvia officinalis sage extract, pogostemon cablin oil, equisetum arvense horsetail extract, caryocar brasiliense pequi oil, citrus aurantium bergamia bergamot fruit oil, anthemis nobilis flower oil, citrus paradisi grapefruit seed oil, lavandula angustifolia lavender oil, citrus aurantium dulcis orange seed oil, cocos nucifera coconut oil, boswellia carterii oil, caprylyl glycol",
      "buy_links": [
        {
          "url": "https://glnk.io/x26q/curlsbot1a7",
          "retailer": "Bounce Curl"
        }
      ],
      "id": "super_smooth_cream_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 5,
          "film_forming_humectants_number": 2,
          "emollients_number": 17,
          "simple_humectants": [
            "Glycerin",
            "Propanediol",
            "Panthenol",
            "Lactic Acid",
            "Caprylyl Glycol"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Marshmallow root Extract"
          ],
          "emollients": [
            "Behentrimonium Methosulfate",
            "Cetearyl Alcohol",
            "Safflower Oil",
            "Stearamidopropyl Dimethylamine",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Lavender Oil",
            "Unknown Oil",
            "Coconut Oil",
            "Unknown Oil"
          ],
          "score": -73
        },
        "porosity": {
          "high": 100,
          "low": 0
        }
      },
      "cost_rating": "5"
    },
    "coil_infusion®_drink_up™_cleansing_conditioner": {
      "name": "Coil Infusion® Drink Up™ Cleansing Conditioner",
      "brand": "Ouidad",
      "product_categories": [
        "cowashes"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity",
        "featured"
      ],
      "ingredients_raw": "aqua water eau, cetearyl alcohol, glycerin, cetyl esters, cetyl alcohol, stearamidopropyl dimethylamine, behentrimonium chloride, butyrospermum parkii shea butter, helianthus annuus sunflower seed oil, propanediol, prunus amygdalus dulcis sweet almond oil, carthamus tinctorius safflower seed oil, ricinus communis castor seed oil, helianthus annuus sunflower extract, rosmarinus officinalis rosemary leaf extract, oryza sativa rice bran extract, euterpe oleracea fruit extract, eucalyptus globulus leaf oil, mauritia flexuosa fruit oil, morinda citrifolia fruit extract, cymbopogon schoenanthus extract, garcinia indica seed butter, sclerocarya birrea seed oil, hydrolyzed rice protein, aloe barbadensis leaf juice, palmitoyl tetrapeptide-20, squalane, tocopherol, hydroxyethylcellulose, capryloyl glycerin sebacic acid copolymer, hydrogenated castor oil sebacic acid copolymer, bht, panthenol, polysorbate 60, guar hydroxypropyltrimonium chloride, stearamine oxide, ethylhexyl olivate, diheptyl succinate, isododecane, citric acid, disodium edta, tetrasodium edta, sodium hydroxide, disodium phosphate, sodium phosphate, butylene glycol, caprylyl glycol, hexylene glycol, sodium benzoate, potassium sorbate, leuconostoc radish root ferment filtrate, chlorphenesin, phenoxyethanol, limonene, linalool, fragrance parfum",
      "buy_links": [
        {
          "url": "https://click.linksynergy.com/link?id=9QcV0uNyab0&offerid=929395.3842995312&type=2&murl=https%3a%2f%2fwww.ouidad.com%2fproducts%2fcoil-infusion-drink-up-cleansing-conditioner%3fvariant%3d42617151357186",
          "retailer": "Ouidad"
        }
      ],
      "id": "coil_infusion®_drink_up™_cleansing_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 6,
          "film_forming_humectants_number": 4,
          "emollients_number": 19,
          "simple_humectants": [
            "Glycerin",
            "Propanediol",
            "Panthenol",
            "Butylene glycol",
            "Caprylyl Glycol",
            "Hexylene Glycol"
          ],
          "film_forming_humectants": [
            "Unknown Protein",
            "Aloe Barbadensis Leaf Extract",
            "Peptide",
            "Hydroxyethylcellulose"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Cetyl Alcohol",
            "Stearamidopropyl Dimethylamine",
            "Behentrimonium Chloride",
            "Butyrospermum Parkii Shea Butter",
            "Sunflower Oil",
            "Sweet Almond Oil",
            "Unknown Oil",
            "Castor Oil",
            "Rice bran oil",
            "Unknown Oil",
            "Unknown Oil",
            "Kokum Butter",
            "Marula Oil",
            "Squalane",
            "Capryloyl Glycerin Sebacic Acid Copolymer",
            "Castor Oil",
            "Guar Hydroxypropyltrimonium Chloride",
            "Diheptyl Succinate"
          ],
          "score": -65
        },
        "porosity": {
          "high": 100,
          "low": 0
        }
      }
    },
    "coconut_cowash_cleansing_conditioner": {
      "name": "Coconut Cowash Cleansing Conditioner",
      "brand": "As I Am",
      "buy_links": [
        {
          "url": "https://amzn.to/3ZXbMQS",
          "retailer": "Amazon"
        }
      ],
      "product_categories": [
        "cowashes"
      ],
      "tags": [
        "high_porosity"
      ],
      "cost": 0.54,
      "ingredients_raw": "aqua water eau, cetyl alcohol, cetrimonium chloride, cetearyl alcohol, cocos nucifera coconut oil, ricinus communis castor seed oil, cocos nucifera coconut fruit powder, citrus reticulata tangerine fruit extract, phytosterols, camillia sinensis leaf extract, peg-40 castor oil, stearlkonium chloride, serenoa serrulata fruit extract, quaternium-18, propylene glycol, c12-15 alkyl lactate, fragrance parfum, potassium sorbate, caprylyl glycol, phenoxyethanol, abies balsamea balsam canada resin, potassium chloride, limonene, glycerin, caprylic capric triglyceride",
      "asin": "B00641UCY8",
      "id": "coconut_cowash_cleansing_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 0,
          "emollients_number": 6,
          "simple_humectants": [
            "Propylene Glycol",
            "Caprylyl Glycol",
            "Glycerin"
          ],
          "film_forming_humectants": [],
          "emollients": [
            "Cetyl Alcohol",
            "Cetrimonium Chloride",
            "Cetearyl Alcohol",
            "Coconut Oil",
            "Castor Oil",
            "Castor Oil"
          ],
          "score": -68
        },
        "porosity": {
          "high": 100,
          "low": 0
        }
      },
      "cost_rating": "1"
    },
    "co-wash_conditioning_cleanser": {
      "name": "Co-wash Conditioning Cleanser",
      "brand": "MopTop",
      "ingredients_raw": "water, glycerin, cetyl alcohol coconut derived, stearyl alcohol coconut derived, olea europaea olive fruit oil, cetrimonium chloride, behentrimonium chloride, aloe barbadensis leaf extract, glycereth-26, hypnea musciformis extract seaweed, gelidiella acerosa extract seaweed, sargassum filipendula extract seaweed, sorbitol, hydroxypropyltrimonium honey, silk amino acids, rosmarinus officinalis rosemary leaf extract, chamomilla recutita matricaria flower extract, urtica dioica nettle extract, butyrospermum parkii shea butter, simmondsia chinensis jojoba seed oil, tocopheryl acetate vitamin e, panthenol vitamin b5, citrus senensis oil, citrus limon oil, citrus aurantifolia oil, citrus paradisi oil, sodium phytate, hydroxyethylcellulose, phenoxyethanol, ethylhexylglycerin, citric acid",
      "product_categories": [
        "cowashes"
      ],
      "buy_links": [
        {
          "url": "https://amzn.to/3P9FvzP",
          "retailer": "Amazon"
        }
      ],
      "tags": [
        "high_porosity"
      ],
      "asin": "B005SIR5G6",
      "cost": 2.12,
      "id": "co-wash_conditioning_cleanser",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 5,
          "film_forming_humectants_number": 7,
          "emollients_number": 11,
          "simple_humectants": [
            "Glycerin",
            "Glycereth-26",
            "Sorbitol",
            "Panthenol",
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Seaweed Extract",
            "Seaweed Extract",
            "Seaweed Extract",
            "Hydroxypropyltrimonium Honey",
            "Silk Amino Acids",
            "Hydroxyethylcellulose"
          ],
          "emollients": [
            "Cetyl Alcohol",
            "Stearyl Alcohol",
            "Olive Oil",
            "Cetrimonium Chloride",
            "Behentrimonium Chloride",
            "Butyrospermum Parkii Shea Butter",
            "Jojoba Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -69
        },
        "porosity": {
          "high": 100,
          "low": 19
        }
      },
      "cost_rating": "4"
    },
    "curl_quenching_conditioning_wash": {
      "name": "Curl Quenching Conditioning Wash",
      "brand": "Curlsmith",
      "product_categories": [
        "cowashes"
      ],
      "tags": [
        "high_porosity"
      ],
      "ingredients_raw": "water aqua, cetearyl alcohol, hydroxypropyl starch phosphate, cetyl palmitate, behentrimonium chloride, cocamidopropyl betaine, fragrance parfum, selaginella lepidophylla resurrection flower extract, carapa guaianensis andiroba seed oil, persea gratissima avocado oil, salvia officinalis sage leaf extract, ocimum basilicum basil leaf extract, piper nigrum black pepper seed extract, aloe barbadensis aloe vera leaf juice, rosmarinus officinalis rosemary leaf extract, helianthus annuus sunflower seed oil, butyrospermum parkii shea butter, cocos nucifera coconut oil, glycerin, guar hydroxypropyltrimonium chloride, panthenol, glyceryl caprylate, glyceryl undecylenate, potassium sorbate, sodium benzoate, sodium hydroxide, sodium chloride, citric acid, disodium edta, limonene, linalool",
      "buy_links": [
        {
          "url": "https://amzn.to/4fU0jXj",
          "retailer": "Amazon",
          "country": "UK"
        },
        {
          "url": "https://amzn.to/4h7ic6o",
          "retailer": "Amazon"
        }
      ],
      "asin": "B07D7CBBPC",
      "id": "curl_quenching_conditioning_wash",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 1,
          "emollients_number": 8,
          "simple_humectants": [
            "Glycerin",
            "Panthenol"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Behentrimonium Chloride",
            "Unknown Oil",
            "Avocado Oil",
            "Sunflower Oil",
            "Butyrospermum Parkii Shea Butter",
            "Coconut Oil",
            "Guar Hydroxypropyltrimonium Chloride"
          ],
          "score": -73
        },
        "porosity": {
          "high": 100,
          "low": 12
        }
      }
    },
    "curl_shaper_double_duty_weightless_cleansing_conditioner": {
      "name": "Curl Shaper Double Duty Weightless Cleansing Conditioner",
      "brand": "Ouidad",
      "product_categories": [
        "cowashes"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity",
        "featured"
      ],
      "buy_links": [
        {
          "url": "https://click.linksynergy.com/link?id=9QcV0uNyab0&offerid=929395.38429941031&type=2&murl=https%3a%2f%2fwww.ouidad.com%2fproducts%2fcurl-shaper-double-duty-weightless-cleansing-conditioner%3fvariant%3d44436704788738",
          "retailer": "Ouidad"
        },
        {
          "url": "https://amzn.to/3PJCVRG",
          "retailer": "Amazon"
        }
      ],
      "ingredients_raw": "aqua water eau, stearyl alcohol, sodium lauroamphoacetate, hydroxypropyl starch phosphate, behentrimonium chloride, cetyl alcohol, cocamidopropyl hydroxysultaine, anastatica hierochuntica extract, oryza sativa rice bran oil, hydroxypropyl bis-hydroxyethyldimonium chloride, hexylene glycol, butylene glycol, ceteareth-20, caprylyl glycol, phenoxyethanol, citric acid, disodium edta, isopropyl alcohol, benzyl salicylate, fragrance parfum",
      "description": "A gentle low pH cleanser. Has a drying alcohol (isopropyl alcohol) but low on the ingredients list and this is less of a concern in a wash-out product.",
      "id": "curl_shaper_double_duty_weightless_cleansing_conditioner",
      "systems_excluded": [],
      "status": "caution",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 0,
          "emollients_number": 5,
          "simple_humectants": [
            "Hexylene Glycol",
            "Butylene glycol",
            "Caprylyl Glycol"
          ],
          "film_forming_humectants": [],
          "emollients": [
            "Stearyl Alcohol",
            "Behentrimonium Chloride",
            "Cetyl Alcohol",
            "Rice bran oil",
            "Ceteareth-20"
          ],
          "score": -59
        },
        "porosity": {
          "high": 100,
          "low": 58
        }
      }
    },
    "hydra_drench_cleansing_conditioner": {
      "name": "Hydra Drench Cleansing Conditioner",
      "brand": "Bounce Curl",
      "product_categories": [
        "cowashes"
      ],
      "tags": [
        "high_porosity"
      ],
      "ingredients_raw": "organic aloe barbadensis leaf juice, glycerin, behentrimonium methosulfate, caprylic capric triglyceride, cetearyl alcohol, sucrose cocoate, stearamidopropyl dimethylamine, propanediol, panthenol, hydrolyzed jojoba esters, vanillin, polyquaternium-10, lactic acid, caprylhydroxamic acid, nigella sativa virgin black cumin oil, althaea officinalis marshmallow root extract, pogostemon cablin oil, citrus paradisi grapefruit seed oil, camellia sinensis green tea leaf extract, rosmarinus officinalis rosemary leaf extract, citrus aurantium bergamia bergamot fruit oil, salvia officinalis sage extract, equisetum arvense horsetail extract, boswellia carterii oil, caryocar brasiliense pequi oil, brassica oleracea italica broccoli seed oil, anthemis nobilis chamomile flower extract, anthemis nobilis flower oil, urtica dioica nettle extract, citrus aurantium dulcis orange seed oil, cocos nucifera coconut oil, citrus nobilis mandarin orange peel oil, tocopheryl acetate, ethylhexylglycerin",
      "buy_links": [
        {
          "url": "https://glnk.io/x26q/curlsbot7tx",
          "retailer": "Bounce Curl"
        }
      ],
      "id": "hydra_drench_cleansing_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 5,
          "film_forming_humectants_number": 2,
          "emollients_number": 15,
          "simple_humectants": [
            "Glycerin",
            "Propanediol",
            "Panthenol",
            "Lactic Acid",
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Marshmallow root Extract"
          ],
          "emollients": [
            "Behentrimonium Methosulfate",
            "Cetearyl Alcohol",
            "Stearamidopropyl Dimethylamine",
            "Unknown Polyquat",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Coconut Oil",
            "Unknown Oil"
          ],
          "score": -68
        },
        "porosity": {
          "high": 100,
          "low": 0
        }
      }
    },
    "lemon_buttercream_styling_cream": {
      "name": "Lemon Buttercream Styling Cream",
      "brand": "Ecoslay",
      "buy_links": [
        {
          "url": "http://ecoslay.sjv.io/19bWvR",
          "retailer": "Ecoslay"
        }
      ],
      "product_categories": [
        "creams"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity",
        "featured",
        "black_owned",
        "woman_owned",
        "small_business"
      ],
      "ingredients_raw": "deionized water aqua, althaea officinalis marshmallow root extract, linum usitatissimum flaxseed extract, cetearyl alcohol, sodium pca, chamomile flower extract, slippery elm extract, peppermint mentha piperita oil, melissa melissa officinalis leaf extract, nettle urtica dioica leaf extract, horsetail equisetum arvense leaf extract, peppermint mentha piperita leaf extract, sage salvia officinalis extract, yucca yucca vera leaf extract, sucrose cocoate, panthenol, caprylhydroxamic acid, glyceryl caprylate, glycerin, citrus limon peel lemon oil, vanilla planifolia fruit oil, potassium sorbate",
      "id": "lemon_buttercream_styling_cream",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 2,
          "emollients_number": 4,
          "simple_humectants": [
            "Sodium PCA",
            "Panthenol",
            "Glycerin"
          ],
          "film_forming_humectants": [
            "Marshmallow root Extract",
            "Flaxseed Extract"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Unknown Oil",
            "Unknown Oil",
            "Vanilla Planifolia Fruit Oil"
          ],
          "score": -81
        },
        "porosity": {
          "high": 85,
          "low": 36
        }
      }
    },
    "i_create_volume": {
      "name": "I Create Volume",
      "brand": "Innersense",
      "ingredients_raw": "water, aqua-eau, aloe barbadensis aloe vera leaf gel, cyamop-sistetragonolobus guar gum, sclerotium gum, citrus aurantium amara bitter orange flower water, organic rooibos african camellia sinensis leaf extract, sodium benzoate, calcium gluconate, potassium sorbate, hydrolyzed rice protein, glycerin, chamomilla recutita matricaria flower extract, eucalyptus globulus leaf extract, ginkgo biloba leaf extract, aspalathus linearis leaf extract, eucalyptus globulus extract, citric acid, maltodextrin, honey extract, linalool, sorbitol, gluconolactone",
      "buy_links": [
        {
          "url": "https://amzn.to/3ZSFbue",
          "retailer": "Amazon"
        },
        {
          "url": "https://shop.beauty-heroes.com/products/i-create-volume-innersense-organic-beauty",
          "retailer": "Beauty Heroes"
        }
      ],
      "product_categories": [
        "gels"
      ],
      "tags": [
        "normal_porosity",
        "low_porosity",
        "volume",
        "featured"
      ],
      "asin": "B002EOSVUQ",
      "cost": 2.8,
      "id": "i_create_volume",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 2,
          "emollients_number": 1,
          "simple_humectants": [
            "Glycerin",
            "Honey",
            "Sorbitol"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Unknown Protein"
          ],
          "emollients": [
            "Guar Gum"
          ],
          "score": -81
        },
        "porosity": {
          "high": 75,
          "low": 100
        }
      },
      "cost_rating": "5"
    },
    "curly_hair_cream": {
      "name": "Curly Hair Cream",
      "brand": "MopTop",
      "buy_links": [
        {
          "url": "https://amzn.to/4fCbwLM",
          "retailer": "Amazon"
        }
      ],
      "product_categories": [
        "creams"
      ],
      "tags": [
        "high_porosity",
        "curl_enhancer",
        "featured",
        "normal_porosity"
      ],
      "ingredients_raw": "water aqua, cetearyl alcohol, glyceryl stearate, propanediol, aloe barbadensis leaf juice, hydrogenated vegetable oil, peg-100 stearate, isopropyl palmitate, pvp, glycerin, caprylic capric triglyceride, glycereth-26, butyrospermum parkii shea butter, vp va copolymer, pectin, hydroxypropyltrimonium honey, coconut alkanes, polyquaternium-55, sodium polyitaconate, triethyl citrate, zea mays corn starch, sodium polyacrylate starch, hypnea musciformis extract, gelidiella acerosa extract, sargassum filipendula extract, sodium lactate, coco-caprylate caprate, ceteareth-20, acrylates beheneth-25 methacrylate copolymer, polyacrylate crosspolymer-6, cellulose, disodium edta, fragrance, phenoxyethanol, benzyl alcohol, aminomethyl propanol",
      "asin": "B0CHWM9YCJ",
      "id": "curly_hair_cream",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 4,
          "film_forming_humectants_number": 3,
          "emollients_number": 10,
          "simple_humectants": [
            "Propanediol",
            "Glycerin",
            "Glycereth-26",
            "Sodium Lactate"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Pectin",
            "Hydroxypropyltrimonium Honey"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Unknown Oil",
            "Polyvinylpyrrolidone",
            "Butyrospermum Parkii Shea Butter",
            "VP VA copolymer",
            "Unknown Polyquat",
            "Ceteareth-20",
            "Copolymer",
            "Polyacrylate Crosspolymer-6",
            "Benzyl Alcohol"
          ],
          "score": -66
        },
        "porosity": {
          "high": 100,
          "low": 43
        }
      }
    },
    "cruise_control_curl_cream": {
      "name": "Cruise Control Curl Cream",
      "brand": "Lohy",
      "buy_links": [
        {
          "url": "https://lohy.com.au/products/cruise-control-curl-cream-curly-hair-styling?aff=49",
          "retailer": "Lohy",
          "country": "AU"
        }
      ],
      "product_categories": [
        "creams"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity",
        "curl_enhancer",
        "featured"
      ],
      "ingredients_raw": "aqua, caprylic capric triglyceride, cetearyl alcohol, glycerin, propanediol, cetrimonium chloride, butyrospermum parkii shea butter, oryza sativa rice bran oil, glyceryl stearate, phenoxyethanol, citrus nobilis mandarin peel oil, hydrolised soy protein, cucumis sativus cucumber fruit extract, chamomila recutita matricaria flower leaf stem extract, camellia sinensis white tea leaf extract, polyquaternium-10, sodium benzoate",
      "cost": 3,
      "id": "cruise_control_curl_cream",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 1,
          "emollients_number": 6,
          "simple_humectants": [
            "Glycerin",
            "Propanediol"
          ],
          "film_forming_humectants": [
            "Unknown Protein"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Cetrimonium Chloride",
            "Butyrospermum Parkii Shea Butter",
            "Rice bran oil",
            "Unknown Oil",
            "Unknown Polyquat"
          ],
          "score": -54
        },
        "porosity": {
          "high": 100,
          "low": 10
        }
      },
      "cost_rating": "5"
    },
    "weightless_air_dry_cream": {
      "name": "Weightless Air Dry Cream",
      "brand": "Curlsmith",
      "product_categories": [
        "creams"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity",
        "curl_enhancer",
        "featured"
      ],
      "ingredients_raw": "water aqua, ricinus communis castor seed oil, dicaprylyl carbonate, cetearyl alcohol, orbignya speciosa babassu kernel oil, behentrimonium chloride, sodium hyaluronate, astrocaryum murumuru seed butter, simmondsia chinensis jojoba seed oil, butyrospermum parkii shea butter, hylocereus undatus dragon fruit fruit extract, paullinia cupana guarana seed extract, urtica dioica nettle leaf extract, zingiber officinale ginger root extract, polyquaternium-10, panthenol, guar hydroxypropyltrimonium chloride, tocopherol, disodium edta, ethylhexylglycerin, glycerin, citric acid, sodium hydroxide, potassium sorbate, sodium benzoate, phenoxyethanol, linalool, limonene, citronellol, fragrance parfum",
      "buy_links": [
        {
          "url": "https://amzn.to/4iZV6zV",
          "retailer": "Amazon",
          "country": "UK"
        },
        {
          "url": "https://amzn.to/4gbWmgy",
          "retailer": "Amazon"
        }
      ],
      "asin": "B08N5CCKJ8",
      "cost": 3.3,
      "id": "weightless_air_dry_cream",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 4,
          "film_forming_humectants_number": 0,
          "emollients_number": 8,
          "simple_humectants": [
            "Sodium hyaluronate",
            "Panthenol",
            "Ethylhexylglycerin",
            "Glycerin"
          ],
          "film_forming_humectants": [],
          "emollients": [
            "Castor Oil",
            "Cetearyl Alcohol",
            "Unknown Oil",
            "Behentrimonium Chloride",
            "Jojoba Oil",
            "Butyrospermum Parkii Shea Butter",
            "Unknown Polyquat",
            "Guar Hydroxypropyltrimonium Chloride"
          ],
          "score": -61
        },
        "porosity": {
          "high": 100,
          "low": 8
        }
      },
      "cost_rating": "5"
    },
    "pinapple_swirl_curl_defining_cream": {
      "name": "Pinapple Swirl Curl Defining Cream",
      "brand": "Pacifica",
      "product_categories": [
        "creams"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity",
        "curl_enhancer",
        "featured"
      ],
      "cost": 3,
      "ingredients_raw": "aqua, cetearyl alcohol, behentrimonium methosulfate, linum usitatissimum linseed seed extract, salvia hispanica seed extract, coco-caprylate, cetyl alcohol, hydroxyethylcellulose, cocos nucifera coconut oil, helianthus annuus sunflower oil, ananas sativus pineapple fruit extract, sodium hyaluronate, phenoxyethanol, ethylhexylglycerin, parfum natural, sodium citrate, citric acid",
      "buy_links": [
        {
          "url": "https://amzn.to/3BXFWKA",
          "retailer": "Amazon"
        },
        {
          "url": "https://fave.co/3Ct5kID",
          "retailer": "Pacifica"
        }
      ],
      "asin": "B07HLJ7MHL",
      "id": "pinapple_swirl_curl_defining_cream",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 2,
          "emollients_number": 5,
          "simple_humectants": [
            "Sodium hyaluronate",
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [
            "Flaxseed Extract",
            "Hydroxyethylcellulose"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Behentrimonium Methosulfate",
            "Cetyl Alcohol",
            "Coconut Oil",
            "Sunflower Oil"
          ],
          "score": -79
        },
        "porosity": {
          "high": 100,
          "low": 30
        }
      },
      "cost_rating": "5"
    },
    "avocado_&_rose_oil_clump_&_define_cream": {
      "name": "Avocado & Rose Oil Clump & Define Cream",
      "brand": "Bounce Curl",
      "product_categories": [
        "creams"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity",
        "curl_enhancer",
        "featured"
      ],
      "ingredients_raw": "water, cetearyl alcohol, persea gratissima avocado oil, caprylic capric triglyceride, aloe barbadensis leaf juice, cetrimonium chloride, vp va copolymer, sorbitol, astrocaryum murumuru seed butter, argania spinosa kernel oil, butyrospermum parkii shea butter, rosa centifolia rose oil, crambe abyssinica seed oil, glycerin, hydroxyethylcellulose, nigella sativa virgin black cumin oil, trigonella foenum-graecum fenugreek seed extract, tocopheryl acetate vitamin e, adansonia digitata baobab seed oil, behentrimonium methosulfate, hydroxypropyl starch phosphate, phenoxyethanol, ethylhexylglycerin",
      "buy_links": [
        {
          "url": "https://glnk.io/x26q/curlsbot52q",
          "retailer": "Bounce Curl"
        }
      ],
      "id": "avocado_&_rose_oil_clump_&_define_cream",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 2,
          "emollients_number": 11,
          "simple_humectants": [
            "Sorbitol",
            "Glycerin",
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Hydroxyethylcellulose"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Avocado Oil",
            "Cetrimonium Chloride",
            "VP VA copolymer",
            "Argan Oil",
            "Butyrospermum Parkii Shea Butter",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Baobab Oil",
            "Behentrimonium Methosulfate"
          ],
          "score": -74
        },
        "porosity": {
          "high": 100,
          "low": 0
        }
      }
    },
    "light_hold_creme_gel": {
      "name": "Light Hold Creme Gel",
      "brand": "Bounce Curl",
      "product_categories": [
        "creams"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity",
        "curl_enhancer",
        "featured"
      ],
      "ingredients_raw": "water, vp va copolymer, glycerin, hydrolyzed jojoba esters, jojoba esters, hydrolyzed quinoa protein, hydrolyzed oat protein, aloe barbadensis leaf extract, panax ginseng root extract, salvia officinalis sage extract, nigella sativa virgin black cumin oil, boswellia carter oil, aminomethyl propanol, carbomer, sodium phytate, caprylyl glycol, hexylene glycol, phenoxyethanol, citric acid",
      "buy_links": [
        {
          "url": "https://glnk.io/x26q/curlsbot86p",
          "retailer": "Bounce Curl"
        }
      ],
      "id": "light_hold_creme_gel",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 3,
          "emollients_number": 3,
          "simple_humectants": [
            "Glycerin",
            "Caprylyl Glycol",
            "Hexylene Glycol"
          ],
          "film_forming_humectants": [
            "Unknown Protein",
            "Hydrolyzed Oat Protein",
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [
            "VP VA copolymer",
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -70
        },
        "porosity": {
          "high": 81,
          "low": 31
        }
      }
    },
    "curl_enhancing_custard": {
      "name": "Curl Enhancing Custard",
      "brand": "MopTop",
      "buy_links": [
        {
          "url": "https://amzn.to/4gMHczc",
          "retailer": "Amazon"
        }
      ],
      "product_categories": [
        "custards"
      ],
      "tags": [
        "low_porosity",
        "curl_enhancer",
        "normal_porosity",
        "high_porosity",
        "featured"
      ],
      "ingredients_raw": "water, glycerin, carboxymethylcellulose, aloe barbadensis leaf extract, pectin, hydroxypropyltrimonium honey, silk amino acids, hypnea musciformis extract seaweed, gelidiella acerosa extract seaweed, sargassum filipendula seaweed extract, sorbitol, rosmarinus officinalis rosemary leaf extract, salix alba willow bark extract, urtica dioica nettle extract, ethylhexylglycerin, phenoxyethanol, citrus senensis oil, citrus limon oil, citrus aurantifolia oil, citrus paradisi oil",
      "asin": "B005SIR12E",
      "cost": 2.3,
      "id": "curl_enhancing_custard",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 7,
          "emollients_number": 4,
          "simple_humectants": [
            "Glycerin",
            "Sorbitol",
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Pectin",
            "Hydroxypropyltrimonium Honey",
            "Silk Amino Acids",
            "Seaweed Extract",
            "Seaweed Extract",
            "Seaweed Extract"
          ],
          "emollients": [
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -81
        },
        "porosity": {
          "high": 97,
          "low": 56
        }
      },
      "cost_rating": "4"
    },
    "curl_defining_styling_souffle": {
      "name": "Curl Defining Styling Souffle",
      "brand": "Curlsmith",
      "ingredients_raw": "water aqua, glycerin, babassu oil polyglyceryl-4 esters, sorbitol, chondrus crispus irish moss powder, fragrance parfum, linum usitatissimum linseed seed extract, carapa guaianensis andiroba seed oil, rosmarinus officinalis rosemary leaf extract, salvia officinalis sage leaf extract, persea gratissima avocado oil, selaginella lepidophylla resurrection flower extract, aloe barbadensis aloe vera leaf juice, ocimum basilicum basil leaf extract, piper nigrum black pepper seed extract, butyrospermum parkii shea butter, helianthus annuus sunflower seed oil, glyceryl caprylate, glyceryl undecylenate, potassium sorbate, sodium benzoate, disodium edta, citric acid, limonene, linalool",
      "product_categories": [
        "custards"
      ],
      "tags": [
        "low_porosity",
        "normal_porosity",
        "high_porosity",
        "featured"
      ],
      "buy_links": [
        {
          "url": "https://amzn.to/40auHbe",
          "retailer": "Amazon",
          "country": "UK"
        },
        {
          "url": "https://amzn.to/40lMISJ",
          "retailer": "Amazon"
        },
        {
          "url": "https://go.skimresources.com?id=276362X1762442&xs=1&url=https%3A%2F%2Fuk.curlsmith.com%2Fproducts%2Fcurl-souffle%3Fredirect%3D1",
          "retailer": "Curlsmith",
          "country": "UK"
        },
        {
          "url": "https://go.skimresources.com?id=276362X1762442&xs=1&url=https%3A%2F%2Fcurlsmith.com%2Fproducts%2Fcurl-souffle",
          "retailer": "Curlsmith"
        }
      ],
      "asin": "B07D7CKKL3",
      "cost": 3.5,
      "id": "curl_defining_styling_souffle",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 3,
          "emollients_number": 5,
          "simple_humectants": [
            "Glycerin",
            "Sorbitol"
          ],
          "film_forming_humectants": [
            "Carrageenan",
            "Flaxseed Extract",
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [
            "Unknown Oil",
            "Unknown Oil",
            "Avocado Oil",
            "Butyrospermum Parkii Shea Butter",
            "Sunflower Oil"
          ],
          "score": -60
        },
        "porosity": {
          "high": 66,
          "low": 3
        }
      },
      "cost_rating": "5"
    },
    "curling_jelly_coil_and_curl_definer_": {
      "name": "Curling Jelly Coil and Curl Definer ",
      "brand": "As I Am",
      "ingredients_raw": "aqueous, water, aqua purificada, purified extracts aloe barbadensis leaf, beta vulgaris beet root, glycerin, hydroxyethylcellulose, xanthan gum, pectin, citric acid, tocopheryl acetate, potassium sorbate, diazolidinyl urea and iodopropynyl butylcarbamate, fragrance parfum, limonene",
      "product_categories": [
        "custards"
      ],
      "tags": [
        "low_porosity",
        "normal_porosity",
        "high_porosity",
        "featured"
      ],
      "buy_links": [
        {
          "url": "https://www.lookfantastic.com/p/as-i-am-curling-jelly-coil-and-curl-definer-227g/11321484/",
          "retailer": "Look Fantastic",
          "country": "UK"
        }
      ],
      "id": "curling_jelly_coil_and_curl_definer_",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 2,
          "emollients_number": 1,
          "simple_humectants": [
            "Glycerin",
            "Urea"
          ],
          "film_forming_humectants": [
            "Hydroxyethylcellulose",
            "Pectin"
          ],
          "emollients": [
            "Xanthan Gum"
          ],
          "score": -68
        },
        "porosity": {
          "high": 85,
          "low": 100
        }
      }
    },
    "gelebration_spray": {
      "name": "Gelebration Spray",
      "brand": "Jessicurl",
      "ingredients_raw": "aqua water, linum usitatissimum linseed flaxseed extract, glycerin, simmondsia chinensis jojoba seed oil, aloe barbadensis aloe vera leaf juice powder, magnesium sulfate, benzoic acid, dehydroacetic acid, phenoxyethanol",
      "product_categories": [
        "custards"
      ],
      "description": "Technically not a custard, but serves the same purpose",
      "tags": [
        "low_porosity",
        "normal_porosity",
        "fragrance_free",
        "liquid_gels",
        "featured",
        "type_2_hair"
      ],
      "buy_links": [
        {
          "url": "https://jessicurl.com/products/gelebration-spray",
          "retailer": "Jessicurl"
        }
      ],
      "id": "gelebration_spray",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 1,
          "film_forming_humectants_number": 2,
          "emollients_number": 1,
          "simple_humectants": [
            "Glycerin"
          ],
          "film_forming_humectants": [
            "Flaxseed Extract",
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [
            "Jojoba Oil"
          ],
          "score": -81
        },
        "porosity": {
          "high": 82,
          "low": 97
        }
      }
    },
    "rockin'_ringlets_styling_potion": {
      "name": "Rockin' Ringlets Styling Potion",
      "brand": "Jessicurl",
      "ingredients_raw": "aqua water, linum usitatissimum linseed flaxseed extract, glycerin, simmondsia chinensis jojoba seed oil, aloe barbadensis aloe vera leaf juice powder, magnesium sulfate, benzoic acid, dehydroacetic acid, phenoxyethanol",
      "product_categories": [
        "custards"
      ],
      "tags": [
        "low_porosity",
        "normal_porosity",
        "high_porosity",
        "featured",
        "type_3_hair",
        "fragrance_free"
      ],
      "buy_links": [
        {
          "url": "https://jessicurl.com/products/rockin-ringlets-styling-potion",
          "retailer": "Jessicurl"
        }
      ],
      "id": "rockin'_ringlets_styling_potion",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 1,
          "film_forming_humectants_number": 2,
          "emollients_number": 1,
          "simple_humectants": [
            "Glycerin"
          ],
          "film_forming_humectants": [
            "Flaxseed Extract",
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [
            "Jojoba Oil"
          ],
          "score": -81
        },
        "porosity": {
          "high": 82,
          "low": 97
        }
      }
    },
    "banana_cream_deep_conditioner": {
      "name": "Banana Cream Deep Conditioner",
      "brand": "Ecoslay",
      "ingredients_raw": "okra extract, marshmallow root extract, aloe vera juice, coconut cream, behentrimonium methosulfate, ceteryl alcohol, avocado oil, argan oil, jojoba oil, benzyl alcohol dehydroacetic acid, banana extract",
      "product_categories": [
        "deep_conditioners"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity",
        "low_porosity",
        "featured",
        "black_owned",
        "woman_owned",
        "small_business"
      ],
      "buy_links": [
        {
          "url": "https://ecoslay.sjv.io/4GdWVM",
          "retailer": "Ecoslay"
        }
      ],
      "asin": "B09D8PL1N5",
      "id": "banana_cream_deep_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 0,
          "film_forming_humectants_number": 2,
          "emollients_number": 6,
          "simple_humectants": [],
          "film_forming_humectants": [
            "Marshmallow root Extract",
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [
            "Behentrimonium Methosulfate",
            "Cetearyl Alcohol",
            "Avocado Oil",
            "Argan Oil",
            "Jojoba Oil",
            "Benzyl Alcohol"
          ],
          "score": -89
        },
        "porosity": {
          "high": 100,
          "low": 0
        }
      }
    },
    "deep_conditioning_treatment": {
      "name": "Deep Conditioning Treatment",
      "brand": "Jessicurl",
      "buy_links": [
        {
          "url": "https://amzn.to/3ZFDa4x",
          "retailer": "Amazon"
        },
        {
          "url": "https://go.skimresources.com?id=276362X1762442&xs=1&url=https%3A%2F%2Fjessicurl.com%2Fproducts%2Fdeep-treatment",
          "retailer": "Jessicurl"
        }
      ],
      "product_categories": [
        "deep_conditioners"
      ],
      "tags": [
        "high_porosity",
        "featured",
        "normal_porosity"
      ],
      "cost": 1.2,
      "ingredients_raw": "aqua water, cetearyl alcohol, butyrospermum parkii shea butter, persea gratissima avocado oil, theobroma cacao cocoa seed butter, behentrimonium methosulfate, aloe barbadensis aloe vera leaf juice powder, equisetum arvense horsetail extract, mentha piperita peppermint leaf extract, rosmarinus officinalis rosemary flower leaf stem extract, laurus nobilis bay laurel leaf extract, ocimum basilicum basil leaf extract, urtica dioica nettle leaf extract, arctium lappa burdock root extract, althea officinalis marshmallow root extract, origanum vulgare oregano leaf extract, cymbopogon flexuosus lemongrass extract, thymus vulgaris thyme leaf extract, salvia officinalis sage leaf extract, lecithin, cinnamal, citral, eugenol, geraniol, citronellol, limonene, linalool, benzoic acid, dehydroacetic acid, phenoxyethanol",
      "asin": "B00684AC82",
      "id": "deep_conditioning_treatment",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 1,
          "film_forming_humectants_number": 2,
          "emollients_number": 4,
          "simple_humectants": [
            "Lecithin"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Marshmallow root Extract"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Butyrospermum Parkii Shea Butter",
            "Avocado Oil",
            "Behentrimonium Methosulfate"
          ],
          "score": -80
        },
        "porosity": {
          "high": 100,
          "low": 6
        }
      },
      "cost_rating": "2"
    },
    "deep_conditioner_&_repair": {
      "name": "Deep Conditioner & Repair",
      "brand": "Love Ur Curls",
      "ingredients_raw": "aqua water eau, butyrospermum parkii shea butter, persea gratissima avocado oil, cetyl alcohol, cetearyl alcohol, behentrimonium chloride, cetrimonium chloride, aloe barbadensis leaf juice, moringa oleifera seed oil, simmondsia chinensis jojoba seed oil, rosmarinus officinalis rosemary leaf oil, ceteareth-20, hydroxyethylcellulose, tocopheryl acetate vitamin e, d-panthenol provitmain b5, phenoxyethanol, ethylhexylglycerin, citric acid, fragrance parfum",
      "buy_links": [
        {
          "url": "https://amzn.to/408QOOY",
          "retailer": "Amazon"
        },
        {
          "url": "https://go.skimresources.com?id=276362X1762442&xs=1&url=https%3A%2F%2Fcurlwarehouse.com%2Fproducts%2Flus-brands-love-ur-curls-deep-condition-repair",
          "retailer": "Curl Warehouse"
        }
      ],
      "product_categories": [
        "deep_conditioners",
        "featured"
      ],
      "tags": [
        "low_porosity",
        "normal_porosity",
        "high_porosity",
        "featured"
      ],
      "asin": "B09YMWHVHD",
      "cost": 3.38,
      "id": "deep_conditioner_&_repair",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 2,
          "emollients_number": 10,
          "simple_humectants": [
            "Panthenol",
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Hydroxyethylcellulose"
          ],
          "emollients": [
            "Butyrospermum Parkii Shea Butter",
            "Avocado Oil",
            "Cetyl Alcohol",
            "Cetearyl Alcohol",
            "Behentrimonium Chloride",
            "Cetrimonium Chloride",
            "Unknown Oil",
            "Jojoba Oil",
            "Unknown Oil",
            "Ceteareth-20"
          ],
          "score": -76
        },
        "porosity": {
          "high": 100,
          "low": 0
        }
      },
      "cost_rating": "5"
    },
    "double_cream_deep_quencher": {
      "name": "Double Cream Deep Quencher",
      "brand": "Curlsmith",
      "product_categories": [
        "deep_conditioners"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity",
        "featured",
        "low_porosity"
      ],
      "ingredients_raw": "water aqua, cetearyl alcohol, behentrimonium chloride, propanediol, hydroxypropyl starch phosphate, cetyl palmitate, fragrance parfum, guar hydroxypropyltrimonium chloride, selaginella lepidophylla resurrection flower extract, carapa guaianensis andiroba seed oil, aloe barbadensis aloe vera leaf juice, ocimum basilicum basil leaf extract, piper nigrum black pepper seed extract, rosmarinus officinalis rosemary leaf extract, salvia officinalis sage leaf extract, helianthus annuus sunflower seed oil, prunus armeniaca apricot kernel oil, persea gratissima avocado oil, butyrospermum parkii shea butter, panthenol, ethylhexylglycerin, citric acid, disodium edta, sodium hydroxide, potassium sorbate, sodium benzoate, glycerin, phenoxyethanol, linalool, limonene",
      "buy_links": [
        {
          "url": "https://amzn.to/4iVdf1y",
          "retailer": "Amazon",
          "country": "UK"
        },
        {
          "url": "https://amzn.to/3Edab0O",
          "retailer": "Amazon"
        },
        {
          "url": "https://go.skimresources.com?id=276362X1762442&xs=1&url=https%3A%2F%2Fcurlsmith.com%2Fproducts%2Fdouble-cream-deep-quencher",
          "retailer": "Curlsmith"
        },
        {
          "url": "https://go.skimresources.com?id=276362X1762442&xs=1&url=https%3A%2F%2Fuk.curlsmith.com%2Fproducts%2Fdouble-cream-deep-quencher",
          "retailer": "Curlsmith",
          "country": "UK"
        }
      ],
      "asin": "B08639DTVD",
      "id": "double_cream_deep_quencher",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 4,
          "film_forming_humectants_number": 1,
          "emollients_number": 8,
          "simple_humectants": [
            "Propanediol",
            "Panthenol",
            "Ethylhexylglycerin",
            "Glycerin"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Behentrimonium Chloride",
            "Guar Hydroxypropyltrimonium Chloride",
            "Unknown Oil",
            "Sunflower Oil",
            "Apricot Kernel Oil",
            "Avocado Oil",
            "Butyrospermum Parkii Shea Butter"
          ],
          "score": -61
        },
        "porosity": {
          "high": 100,
          "low": 23
        }
      }
    },
    "lemon_drop_styling_foam": {
      "name": "Lemon Drop Styling Foam",
      "brand": "Ecoslay",
      "ingredients_raw": "purified water aqua, mel, hydrolyzed corn starch, sodium polyitaconate, sucrose, propanediol, capryl caprylyl glucoside, linum usitatissimum seed extract, althaea officinalis root extract, antimicro root blend preservative bulb extract, caprylyl glycol, wasabia japonica root extract, zingiber officinale root extract, citrus limon peel oil, citrus aurantium bergamia fruit oil",
      "product_categories": [
        "foams"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity",
        "low_porosity",
        "featured",
        "black_owned",
        "woman_owned",
        "small_business"
      ],
      "buy_links": [
        {
          "url": "https://ecoslay.sjv.io/7abJPr",
          "retailer": "Ecoslay"
        }
      ],
      "asin": "B09D8PL1N5",
      "id": "lemon_drop_styling_foam",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 2,
          "emollients_number": 2,
          "simple_humectants": [
            "Propanediol",
            "Caprylyl Glycol"
          ],
          "film_forming_humectants": [
            "Hydrolyzed Corn Starch",
            "Linum Usitatissimum Seed Extract"
          ],
          "emollients": [
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -77
        },
        "porosity": {
          "high": 91,
          "low": 41
        }
      }
    },
    "chutzpah_volumising_foam": {
      "name": "Chutzpah Volumising Foam",
      "brand": "Lohy",
      "buy_links": [
        {
          "url": "https://lohy.com.au/products/chutzpah-volumising-curl-foam?aff=49",
          "retailer": "Lohy",
          "country": "AU"
        }
      ],
      "product_categories": [
        "foams"
      ],
      "tags": [
        "low_porosity",
        "curl_enhancer",
        "normal_porosity",
        "featured"
      ],
      "ingredients_raw": "aqua, aloe barbadensis aloe vera leaf juice, pullulan, galactoarabinan, glycerin, propanediol, lauryl glucoside, decyl glucoside, cocamidopropyl betaine, camellia sinensis white tea leaf extract, chamomila recutita matricaria flower leaf stem extract, phenoxyethanol, hydrolised soy protein, potassium sorbate, citric acid, citrus limon lemon peel oil, pelargonium graveolens geranium flower oil",
      "cost": 4.4,
      "id": "chutzpah_volumising_foam",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 2,
          "emollients_number": 2,
          "simple_humectants": [
            "Glycerin",
            "Propanediol"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Unknown Protein"
          ],
          "emollients": [
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -73
        },
        "porosity": {
          "high": 90,
          "low": 47
        }
      },
      "cost_rating": "5"
    },
    "i_create_lift_volumizing_foam": {
      "name": "I Create Lift Volumizing Foam",
      "brand": "Innersense",
      "buy_links": [
        {
          "url": "https://amzn.to/3DA6phV",
          "retailer": "Amazon"
        },
        {
          "url": "https://go.skimresources.com?id=276362X1762442&xs=1&url=https%3A%2F%2Fshop.beauty-heroes.com%2Fproducts%2Fi-create-lift-innersense-organic-beauty",
          "retailer": "Beauty Heroes"
        }
      ],
      "product_categories": [
        "foams"
      ],
      "tags": [
        "normal_porosity",
        "volume",
        "low_porosity",
        "featured"
      ],
      "asin": "B079B3HKZK",
      "ingredients_raw": "water, pullulan, galactoarabinan, aloe barbadensis aloe vera leaf juice, glycerin, caprylyl capryl glucoside, gluconolactone, sodium benzoate, calcium gluconate, hydrolyzed rice protein, decyl glucoside, lauryl glucoside, sorbitol, potassium sorbate, cananga odorata flower oil, lavandula angustifolia lavender oil, citrus aurantium dulcis orange peel oil, salvia sclarea clary oil, vanillin, pogostemon cablin patchouli oil, glycine soja soybean oil, hydroxypropyltrimonium honey, sorbic acid, citric acid, diheptyl succinate, capryloyl glycerin sebacic acid copolymer, vaccinium macrocarpon cranberry seed oil, vitis vinifera grape seed oil, cucurbita pepo pumpkin seed oil, macadamia ternifolia seed oil, macelignan, tocopherol, linalool, limonene",
      "cost": 4.6,
      "id": "i_create_lift_volumizing_foam",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 3,
          "emollients_number": 12,
          "simple_humectants": [
            "Glycerin",
            "Sorbitol"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Unknown Protein",
            "Hydroxypropyltrimonium Honey"
          ],
          "emollients": [
            "Unknown Oil",
            "Lavender Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Diheptyl Succinate",
            "Capryloyl Glycerin Sebacic Acid Copolymer",
            "Unknown Oil",
            "Grapeseed Oil",
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -75
        },
        "porosity": {
          "high": 96,
          "low": 0
        }
      },
      "cost_rating": "5"
    },
    "bouncy_strength_volume_foam": {
      "name": "Bouncy Strength Volume Foam",
      "brand": "Curlsmith",
      "product_categories": [
        "foams"
      ],
      "tags": [
        "normal_porosity",
        "volume",
        "low_porosity",
        "featured"
      ],
      "ingredients_raw": "water aqua, vp va copolymer, cocamidopropyl betaine, hydrolyzed rice protein, hydrolyzed hemp seed extract, ribes nigrum black currant fruit extract, lentinus edodes shiitake mushroom extract, psidium guajava guava fruit extract, brassica oleracea acephala kale leaf extract, cucurbita pepo pumpkin seed extract, opuntia tuna prickly pear fruit extract, glycerin, panthenol, potassium sorbate, ethylhexylglycerin, disodium edta, citric acid, sodium benzoate, peg-40 hydrogenated castor oil, phenoxyethanol, sodium hydroxide, linalool, limonene, geraniol, benzyl alcohol, fragrance parfum",
      "buy_links": [
        {
          "url": "https://amzn.to/49W9HrK",
          "retailer": "Amazon",
          "country": "UK"
        },
        {
          "url": "https://go.skimresources.com?id=276362X1762442&xs=1&url=https%3A%2F%2Fcurlsmith.com%2Fproducts%2Fbouncy-strength-volume-foam",
          "retailer": "Curlsmith"
        },
        {
          "url": "https://go.skimresources.com?id=276362X1762442&xs=1&url=https%3A%2F%2Fuk.curlsmith.com%2Fproducts%2Fbouncy-strength-volume-foam",
          "retailer": "Curlsmith",
          "country": "UK"
        }
      ],
      "asin": "B08WPSW84H",
      "cost": 2.6,
      "id": "bouncy_strength_volume_foam",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 1,
          "emollients_number": 3,
          "simple_humectants": [
            "Glycerin",
            "Panthenol",
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [
            "Unknown Protein"
          ],
          "emollients": [
            "VP VA copolymer",
            "Castor Oil",
            "Benzyl Alcohol"
          ],
          "score": -70
        },
        "porosity": {
          "high": 72,
          "low": 77
        }
      },
      "cost_rating": "5"
    },
    "curl_boosting_hair_mousse": {
      "name": "Curl Boosting Hair Mousse",
      "brand": "Herbal Essences",
      "product_categories": [
        "foams"
      ],
      "ingredients_raw": "water, isobutane, propane, polyquaternium-4, phenoxyethanol, propylene glycol, fragrance, c9-11 pareth-8, caprylyl glycol, 12-hexanediol, disodium edta, citric acid",
      "tags": [
        "normal_porosity",
        "volume",
        "low_porosity"
      ],
      "buy_links": [
        {
          "url": "https://amzn.to/41UCcnP",
          "retailer": "Amazon"
        },
        {
          "url": "https://www.cvs.com/shop/herbal-essences-curl-boosting-mousse-6-8-oz-prodid-184956",
          "retailer": "CVS"
        }
      ],
      "asin": "B0B995XZ6T",
      "cost": 0.7,
      "id": "curl_boosting_hair_mousse",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 0,
          "emollients_number": 1,
          "simple_humectants": [
            "Propylene Glycol",
            "Caprylyl Glycol"
          ],
          "film_forming_humectants": [],
          "emollients": [
            "Unknown Polyquat"
          ],
          "score": -18
        },
        "porosity": {
          "high": 100,
          "low": 100
        }
      },
      "cost_rating": "1"
    },
    "jello_shot_curl_defining_gel": {
      "name": "Jello Shot Curl Defining Gel",
      "brand": "Ecoslay",
      "ingredients_raw": "water, okra extract, aloe vera juice, pectin, chamomile flower extract, nettle leaf extract, melissa leaf extract, peppermint leaf extract, horsetail leaf extract, yucca vera leaf extract, propanediol, aminopropanol, strawberry fruit essence, benzyl alcohol dehydroacetic acid, carbomer 980, sodium gluconate",
      "product_categories": [
        "gels"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity",
        "low_porosity",
        "curl_enhancer",
        "featured",
        "black_owned",
        "woman_owned",
        "small_business"
      ],
      "buy_links": [
        {
          "url": "https://ecoslay.sjv.io/55j7vj",
          "retailer": "Ecoslay"
        }
      ],
      "id": "jello_shot_curl_defining_gel",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 1,
          "film_forming_humectants_number": 2,
          "emollients_number": 1,
          "simple_humectants": [
            "Propanediol"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Pectin"
          ],
          "emollients": [
            "Benzyl Alcohol"
          ],
          "score": -91
        },
        "porosity": {
          "high": 100,
          "low": 100
        }
      }
    },
    "orange_marmalade_flaxseed_and_aloe_curl_definer": {
      "name": "Orange Marmalade Flaxseed and Aloe Curl Definer",
      "brand": "Ecoslay",
      "ingredients_raw": "flaxseed extract, agave nectar extract, pectin, aloe vera juice, marshmallow root extract, vitamin e, xanthan gum, optiphen plus, sweet orange essential oil",
      "product_categories": [
        "gels",
        "custards"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity",
        "low_porosity",
        "curl_enhancer",
        "featured",
        "black_owned",
        "woman_owned",
        "small_business"
      ],
      "description": "CurlsBot note: This is the main styling product I use on my own hair- Melissa",
      "buy_links": [
        {
          "url": "https://ecoslay.sjv.io/qzg2M5",
          "retailer": "Ecoslay"
        }
      ],
      "id": "orange_marmalade_flaxseed_and_aloe_curl_definer",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 1,
          "film_forming_humectants_number": 4,
          "emollients_number": 2,
          "simple_humectants": [
            "Agave Nectar"
          ],
          "film_forming_humectants": [
            "Flaxseed Extract",
            "Pectin",
            "Aloe Barbadensis Leaf Extract",
            "Marshmallow root Extract"
          ],
          "emollients": [
            "Xanthan Gum",
            "Unknown Essential Oil"
          ],
          "score": -88
        },
        "porosity": {
          "high": 100,
          "low": 100
        }
      }
    },
    "advanced_climate_control_heat_&_humidity_gel": {
      "name": "Advanced Climate Control Heat & Humidity Gel",
      "brand": "Ouidad",
      "ingredients_raw": "water aqua eau, butylene glycol, polyquaternium-28, sericin, chamomilla recutita matricaria flower extract, actinidia chinensis kiwi fruit extract, cassia auriculata leaf extract, wheat amino acids, hydrolyzed wheat protein pvp crosspolymer, tocopheryl acetate, retinyl palmitate, panthenol, polyquaternium-7, guar hydroxypropyltrimonium chloride, behentrimonium chloride, cetrimonium chloride, peg-60 almond glycerides, glycerin, ppg-26-buteth-26, peg-40 hydrogenated castor oil, vp dmapa acrylates copolymer, hydroxyethylcellulose, potassium sorbate, disodium edta, hexylene glycol, caprylyl glycol, ethylhexylglycerin, phenoxyethanol, parfum fragrance, alpha-lsomethyl lonone, benzyl benzoate, benzyl salicylate, citronellol, hexyl cinnamal, hydroxycitronellal, limonene, linalool",
      "product_categories": [
        "gels"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity",
        "low_porosity",
        "hold",
        "featured"
      ],
      "cost": 3,
      "buy_links": [
        {
          "url": "https://click.linksynergy.com/link?id=9QcV0uNyab0&offerid=929395.3842993508&type=2&murl=https%3a%2f%2fwww.ouidad.com%2fproducts%2fadvanced-climate-control-heat-and-humidity-gel%3fvariant%3d42617150865666",
          "retailer": "Ouidad"
        }
      ],
      "id": "advanced_climate_control_heat_&_humidity_gel",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 6,
          "film_forming_humectants_number": 4,
          "emollients_number": 7,
          "simple_humectants": [
            "Butylene glycol",
            "Panthenol",
            "Glycerin",
            "Hexylene Glycol",
            "Caprylyl Glycol",
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [
            "Silk",
            "Wheat Amino Acids",
            "Hydrolyzed Wheat Protein",
            "Hydroxyethylcellulose"
          ],
          "emollients": [
            "Unknown Polyquat",
            "Unknown Polyquat",
            "Guar Hydroxypropyltrimonium Chloride",
            "Behentrimonium Chloride",
            "Cetrimonium Chloride",
            "Castor Oil",
            "Acrylates Copolymer"
          ],
          "score": -64
        },
        "porosity": {
          "high": 100,
          "low": 77
        }
      },
      "cost_rating": "5"
    },
    "coil_infusion®_good_shape®_defining_gel": {
      "name": "Coil Infusion® Good Shape® Defining Gel",
      "brand": "Ouidad",
      "product_categories": [
        "gels"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity",
        "featured"
      ],
      "cost": 3.5,
      "buy_links": [
        {
          "url": "https://click.linksynergy.com/link?id=9QcV0uNyab0&offerid=929395.3842995708&type=2&murl=https%3a%2f%2fwww.ouidad.com%2fproducts%2fcoil-infusion-good-shape-defining-gel%3fvariant%3d42617151488258",
          "retailer": "Ouidad"
        }
      ],
      "ingredients_raw": "aqua water eau, polyquaternium-11, polyquaternium-37, argania spinosa argan oil, ricinus communis castor seed oil, hydrolyzed wheat protein, aloe barbadensis leaf juice, polyquaternium-7, panthenol, sericin, ppg-3 benzyl ether myristate, glycerin, pvp, hydroxyethylcellulose, isoceteth-20, citric acid, behentrimonium chloride, cetrimonium chloride, guar hydroxypropyltrimonium chloride, hydroxypropyl bis-hydroxyethyldimonium chloride, disodium edta, caprylyl glycol, iodopropynyl butylcarbamate, phenoxyethanol, limonene, linalool, fragrance parfum",
      "id": "coil_infusion®_good_shape®_defining_gel",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 4,
          "emollients_number": 9,
          "simple_humectants": [
            "Panthenol",
            "Glycerin",
            "Caprylyl Glycol"
          ],
          "film_forming_humectants": [
            "Hydrolyzed Wheat Protein",
            "Aloe Barbadensis Leaf Extract",
            "Silk",
            "Hydroxyethylcellulose"
          ],
          "emollients": [
            "Unknown Polyquat",
            "Unknown Polyquat",
            "Argan Oil",
            "Castor Oil",
            "Unknown Polyquat",
            "Polyvinylpyrrolidone",
            "Behentrimonium Chloride",
            "Cetrimonium Chloride",
            "Guar Hydroxypropyltrimonium Chloride"
          ],
          "score": -78
        },
        "porosity": {
          "high": 100,
          "low": 48
        }
      },
      "cost_rating": "5"
    },
    "i_create_hold": {
      "name": "I Create Hold",
      "brand": "Innersense",
      "buy_links": [
        {
          "url": "https://amzn.to/2BYccc7",
          "retailer": "Amazon"
        },
        {
          "url": "https://shop.beauty-heroes.com/products/i-create-hold-innersense-organic-beauty",
          "retailer": "Beauty Heroes"
        }
      ],
      "product_categories": [
        "gels"
      ],
      "tags": [
        "normal_porosity",
        "hold",
        "high_porosity",
        "featured"
      ],
      "cost": 2.8,
      "ingredients_raw": "water, aqua-eau, aloe barbadensis gel, hydroxyethylcellulose, maltodextrin copolymer, potassium hydroxide, gluconolactone, sodium benzoate, calcium gluconate, alkyl acrylate crosspolymer, citrus aurantium dulcis peel oil, caprylic capric triglyceride, potassium sorbate, sodium phytate, glycerin, chamomilla recutita matricaria flower extract, eucalyptus globulus leaf extract, ginkgo biloba leaf extract, aspalathus linearis leaf extract, honey extract, limonene",
      "asin": "B002EOUQR2",
      "id": "i_create_hold",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 1,
          "emollients_number": 2,
          "simple_humectants": [
            "Glycerin",
            "Honey"
          ],
          "film_forming_humectants": [
            "Hydroxyethylcellulose"
          ],
          "emollients": [
            "Copolymer",
            "Citrus Aurantium Dulcis Peel Oil"
          ],
          "score": -79
        },
        "porosity": {
          "high": 82,
          "low": 100
        }
      },
      "cost_rating": "5"
    },
    "curl_enhancer_gel": {
      "name": "Curl Enhancer Gel",
      "brand": "MopTop",
      "ingredients_raw": "water, aloe barbadensis leaf extract, polyacrylate-2 crosspolymer, maltodextrin vp copolymer, hydroxyethylcellulose, hydroxypropyltrimonium honey, laminaria saccharina algae extract, fucus vesiculosus bladderwrack extract, arnica montana flower extract, urtica dioica nettle extract, chamomilla recutita matricaria flower extract, silk amino acids, glycerin, sodium hydroxide, polyquaternium-10, ethylhexylglycerin, polysorbate-20, panthenol, phytic acid, phenoxyethanol, fragrance",
      "buy_links": [
        {
          "url": "https://amzn.to/4iLNscf",
          "retailer": "Amazon"
        }
      ],
      "product_categories": [
        "gels"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity",
        "low_porosity",
        "curl_enhancer",
        "featured"
      ],
      "asin": "B093XG3RDK",
      "cost": 2.5,
      "id": "curl_enhancer_gel",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 5,
          "emollients_number": 2,
          "simple_humectants": [
            "Glycerin",
            "Ethylhexylglycerin",
            "Panthenol"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Hydroxyethylcellulose",
            "Hydroxypropyltrimonium Honey",
            "Algae Extract",
            "Silk Amino Acids"
          ],
          "emollients": [
            "Maltodextrin VP Copolymer",
            "Unknown Polyquat"
          ],
          "score": -89
        },
        "porosity": {
          "high": 100,
          "low": 100
        }
      },
      "cost_rating": "4"
    },
    "irish_sea_moss_styling_gel": {
      "name": "Irish Sea Moss Styling Gel",
      "brand": "Love Ur Curls",
      "ingredients_raw": "aqua water eau, chondrus crispus irish sea moss extract, passiflora edulis passion fruit seed oil, euterpe oleracea acai fruit oil, oryza sativa rice bran oil, aloe barbadensis aloe vera leaf extract, polyquaternium-37, sorbitol, polyquaternium-69, behentrimonium chloride, guar hydroxypropyltrimonium chloride, hydroxyethylcellulose, citric acid, glycerin, phenoxyethanol, ethylhexylglycerin, fragrance parfum",
      "product_categories": [
        "gels"
      ],
      "tags": [
        "low_porosity",
        "normal_porosity",
        "hold",
        "featured"
      ],
      "buy_links": [
        {
          "url": "https://amzn.to/4fyvVl5",
          "retailer": "Amazon"
        },
        {
          "url": "https://curlwarehouse.com/products/love-ur-curls-irish-sea-moss-gel",
          "retailer": "Curl Warehouse"
        }
      ],
      "asin": "B09YMYDNX8",
      "id": "irish_sea_moss_styling_gel",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 3,
          "emollients_number": 7,
          "simple_humectants": [
            "Sorbitol",
            "Glycerin",
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [
            "Carrageenan",
            "Aloe Barbadensis Leaf Extract",
            "Hydroxyethylcellulose"
          ],
          "emollients": [
            "Unknown Oil",
            "Unknown Oil",
            "Rice bran oil",
            "Unknown Polyquat",
            "Unknown Polyquat",
            "Behentrimonium Chloride",
            "Guar Hydroxypropyltrimonium Chloride"
          ],
          "score": -80
        },
        "porosity": {
          "high": 100,
          "low": 29
        }
      }
    },
    "pow_strong_hold_gel": {
      "name": "POW Strong Hold Gel",
      "brand": "Lohy",
      "ingredients_raw": "aqua, aloe barbadensis aloe vera leaf juice, polyquaternium-10, glycerin, propanediol, vp va copolymer, phenoxyethanol, hydrolysed soy protein, camellia sinensis white tea leaf extract, chamomilla recutita matricaria flower leaf stem extract, sodium benzoate, eucalyptus globulus leaf oil, mentha arvensis peppermint leaf oil",
      "product_categories": [
        "gels"
      ],
      "tags": [
        "normal_porosity",
        "low_porosity",
        "hold",
        "featured"
      ],
      "buy_links": [
        {
          "url": "https://lohy.com.au/products/pow-strong-hold-gel-curly-hair?aff=49",
          "retailer": "Lohy",
          "country": "AU"
        }
      ],
      "id": "pow_strong_hold_gel",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 2,
          "emollients_number": 4,
          "simple_humectants": [
            "Glycerin",
            "Propanediol"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Unknown Protein"
          ],
          "emollients": [
            "Unknown Polyquat",
            "VP VA copolymer",
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -73
        },
        "porosity": {
          "high": 100,
          "low": 63
        }
      }
    },
    "oomph_hydrating_gel": {
      "name": "Oomph Hydrating Gel",
      "brand": "Lohy",
      "ingredients_raw": "aqua, aloe barbadensis aloe vera leaf juice, pullulan, glycerin, propanediol, camellia sinensis white tea leaf extract, chamomilla recutita matricaria flower leaf stem extract, cyamopsis tetragonoloba guar gum, phenoxyethanol, hydrolysed soy protein, potassium sorbate, citrus limon lemon peel oil, pelargonium graveolens geranium flower oil",
      "product_categories": [
        "gels"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity",
        "volume",
        "featured"
      ],
      "buy_links": [
        {
          "url": "https://lohy.com.au/products/oomph-volumising-lotion-curly-hair-styling?aff=49",
          "retailer": "Lohy",
          "country": "AU"
        }
      ],
      "id": "oomph_hydrating_gel",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 2,
          "emollients_number": 3,
          "simple_humectants": [
            "Glycerin",
            "Propanediol"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Unknown Protein"
          ],
          "emollients": [
            "Guar Gum",
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -71
        },
        "porosity": {
          "high": 79,
          "low": 53
        }
      }
    },
    "hydro_style_flexi-jelly": {
      "name": "Hydro Style Flexi-Jelly",
      "brand": "Curlsmith",
      "product_categories": [
        "gels"
      ],
      "tags": [
        "normal_porosity",
        "low_porosity",
        "curl_enhancer",
        "featured",
        "high_porosity"
      ],
      "ingredients_raw": "water aqua, pvp, peg-40 hydrogenated castor oil, sodium hyaluronate, camellia sinensis green tea leaf extract, lavandula angustifolia lavender flower extract, thymus vulgaris thyme leaf extract, thuja occidentalis white cedar leaf extract, phyllanthus emblica amla fruit extract, panthenol, disodium edta, carbomer, caprylyl glycol, sodium benzoate, potassium sorbate, aminomethyl propanol, glycerin, phenoxyethanol, ethylhexylglycerin, linalool, limonene, citronellol, fragrance parfum",
      "buy_links": [
        {
          "url": "https://amzn.to/3BHjZj1",
          "retailer": "Amazon",
          "country": "UK"
        },
        {
          "url": "https://curlsmith.com/products/hydro-style-flexi-jelly",
          "retailer": "Curlsmith"
        },
        {
          "url": "https://uk.curlsmith.com/products/hydro-style-flexi-jelly",
          "retailer": "Curlsmith",
          "country": "UK"
        }
      ],
      "asin": "B08N5BX78W",
      "id": "hydro_style_flexi-jelly",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 5,
          "film_forming_humectants_number": 0,
          "emollients_number": 2,
          "simple_humectants": [
            "Sodium hyaluronate",
            "Panthenol",
            "Caprylyl Glycol",
            "Glycerin",
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [],
          "emollients": [
            "Polyvinylpyrrolidone",
            "Castor Oil"
          ],
          "score": -32
        },
        "porosity": {
          "high": 60,
          "low": 65
        }
      }
    },
    "la_hold_styling_gel": {
      "name": "LA Hold Styling Gel",
      "brand": "Giovanni",
      "buy_links": [
        {
          "url": "https://amzn.to/4fKkExP",
          "retailer": "Amazon",
          "country": "UK"
        },
        {
          "url": "https://www.vitacost.com/giovanni-l-a-natural-styling-gel-strong-hold",
          "retailer": "Vitacost"
        },
        {
          "url": "https://amzn.to/4glSQ3s",
          "retailer": "Amazon"
        }
      ],
      "cost": 1,
      "tags": [
        "normal_porosity",
        "low_porosity",
        "curl_enhancer",
        "high_porosity"
      ],
      "ingredients_raw": "aqua purified water, vp va copolymer, hydroxyethylcellulose plant derived, tocopherol vitamin e, citric acid, phenoxyethanol, citrus grandis grapefruit seed extract, fragrance includes essential oils, aloe barbadensis aloe vera leaf juice, helianthus annuus sunflower seed oil, glycine soja soybean seed extract, betula alba extract, malva sylvestris mallow extract, achillea millefolium extract, chamomilla recutita matricaria flower extract, equisetum arvense extract, lavandula angustifolia lavender extract, rosmarinus officinalis rosemary leaf extract, salvia sclarea clary extract, thymus vulgaris thyme extract, tussilago farfara coltsfoot flower extract, urtica dioica nettle extract",
      "product_categories": [
        "gels"
      ],
      "id": "la_hold_styling_gel",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 0,
          "film_forming_humectants_number": 3,
          "emollients_number": 3,
          "simple_humectants": [],
          "film_forming_humectants": [
            "Hydroxyethylcellulose",
            "Aloe Barbadensis Leaf Extract",
            "Glycine"
          ],
          "emollients": [
            "VP VA copolymer",
            "Unknown Essential Oil",
            "Sunflower Oil"
          ],
          "score": -90
        },
        "porosity": {
          "high": 92,
          "low": 84
        }
      },
      "cost_rating": "1"
    },
    "curl_keeper®_original_liquid_styler": {
      "name": "Curl Keeper® Original Liquid Styler",
      "brand": "Curl Keeper",
      "product_categories": [
        "gels",
        "fragrance-free"
      ],
      "tags": [
        "normal_porosity",
        "low_porosity",
        "featured"
      ],
      "cost": 2.9,
      "buy_links": [
        {
          "url": "https://curlkeeper.com/r?id=p0m4m5",
          "retailer": "Curl Keeper"
        }
      ],
      "ingredients_raw": "water aqua eau, vp va copolymer, propylene glycol, hydroxyethylcellulose, glycerin, oleth-20, polyquaternium-10, citric acid, dmdm hydantoin",
      "id": "curl_keeper®_original_liquid_styler",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 1,
          "emollients_number": 2,
          "simple_humectants": [
            "Propylene Glycol",
            "Glycerin"
          ],
          "film_forming_humectants": [
            "Hydroxyethylcellulose"
          ],
          "emollients": [
            "VP VA copolymer",
            "Unknown Polyquat"
          ],
          "score": -54
        },
        "porosity": {
          "high": 100,
          "low": 99
        }
      },
      "cost_rating": "5"
    },
    "spiralicious": {
      "name": "Spiralicious",
      "brand": "Jessicurl",
      "ingredients_raw": "aqua water, polyquaternium-69, polyquaternium-11, hydroxyethylcellulose, simmondsia chinensis jojoba seed oil, panthenol, parfum fragrance, c12-15 alkyl benzoate, diazolidinyl urea, iodopropynyl butylcarbamate, alcohol, coumarin, limonene",
      "product_categories": [
        "gels"
      ],
      "tags": [
        "low_porosity",
        "normal_porosity",
        "featured",
        "liquid_gels"
      ],
      "buy_links": [
        {
          "url": "https://jessicurl.com/products/spiralicious-styling-gel",
          "retailer": "Jessicurl"
        }
      ],
      "id": "spiralicious",
      "systems_excluded": [],
      "status": "caution",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 1,
          "emollients_number": 3,
          "simple_humectants": [
            "Panthenol",
            "Urea"
          ],
          "film_forming_humectants": [
            "Hydroxyethylcellulose"
          ],
          "emollients": [
            "Unknown Polyquat",
            "Unknown Polyquat",
            "Jojoba Oil"
          ],
          "score": -70
        },
        "porosity": {
          "high": 100,
          "low": 88
        }
      }
    },
    "rice_pudding_leave-in_conditioner_and_moisturizer": {
      "name": "Rice Pudding Leave-In Conditioner and Moisturizer",
      "brand": "Ecoslay",
      "product_categories": [
        "leave_ins"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity",
        "featured",
        "black_owned",
        "woman_owned",
        "small_business"
      ],
      "ingredients_raw": "water, marshmallow root extract, fermented rice water, cetearyl alcohol, sodium pca, chamomile flower extract, slippery elm extract, nettle leaf extract, melissa leaf extract, peppermint leaf extract, horsetail leaf extract, yucca vera leaf extract, sucrose cocoate, panthenol, capryhydroxamic acid gg, jasmine essential oil, vanilla essential oil, potassium sorbate",
      "buy_links": [
        {
          "url": "http://ecoslay.sjv.io/6yGgNb",
          "retailer": "Ecoslay"
        }
      ],
      "id": "rice_pudding_leave-in_conditioner_and_moisturizer",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 1,
          "emollients_number": 3,
          "simple_humectants": [
            "Sodium PCA",
            "Panthenol"
          ],
          "film_forming_humectants": [
            "Marshmallow root Extract"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Unknown Essential Oil",
            "Unknown Essential Oil"
          ],
          "score": -75
        },
        "porosity": {
          "high": 78,
          "low": 100
        }
      }
    },
    "sweet_spirit_leave-in_conditioner": {
      "name": "Sweet Spirit Leave-In Conditioner",
      "brand": "Innersense",
      "buy_links": [
        {
          "url": "https://amzn.to/2yjHQ1r",
          "retailer": "Amazon"
        },
        {
          "url": "https://shop.beauty-heroes.com/products/sweet-spirit-leave-in-conditioner-innersense-organic-beauty",
          "retailer": "Beauty Heroes"
        }
      ],
      "product_categories": [
        "leave_ins"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity",
        "featured"
      ],
      "cost": 2.8,
      "asin": "B004KM1OEK",
      "ingredients_raw": "water aqua- eau, aloe barbadensis aloe vera leaf gel, cetearyl alcohol, glycerin, distearoylethyl dimonium chloride, caprylic capric triglyceride, hydrolyzed quinoa, gluconolactone, sodium benzoate, calcium gluconate, potassium sorbate, benzyl acetate, linalyl acetate, citronellol, abies balsamea needle oil, juniperus virginiana cedar oil, alpha-terpineol, amyl cinnamal, linalool, pogostemon cablin leaf oil, salvia sclarea clary sage oil, citrus reticulata tangerine peel oil, mentha citrata herb oil, eugenia caryophyllus clove oil, michelia alba leaf oil, lavandula angustifolia lavender oil, citrus limon lemon peel oil, citrus aurantifolia lime oil, lavandula hybrida lavandin oil, cinnamomum camphora camphor bark oil, alpha-lonone, evernia prunastri oakmoss extract, anisaldehyde, cistus ladaniferus resin, menthol, myristica fragrans nutmeg kernel oil, jasminum grandiflorum flower jasmine extract, nerol, benzaldehyde, chamomilla recutita matricaria flower extract, eucalyptus globulus leaf extract, ginkgo biloba leaf extract, aspalathus linearis leaf extract, honey extract, calophyllum inophyllum tamanu oil, rosmarinus officinalis rosemary oil, citric acid, eugenol, limonene",
      "id": "sweet_spirit_leave-in_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 1,
          "emollients_number": 17,
          "simple_humectants": [
            "Glycerin",
            "Honey"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Lavender Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Rosemary Oil"
          ],
          "score": -76
        },
        "porosity": {
          "high": 53,
          "low": 0
        }
      },
      "cost_rating": "5"
    },
    "hydrate_&_plump_leave-in_conditioner": {
      "name": "Hydrate & Plump Leave-In Conditioner",
      "brand": "Curlsmith",
      "product_categories": [
        "leave_ins"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity",
        "featured"
      ],
      "ingredients_raw": "water aqua eau, dicaprylyl carbonate, cetearyl alcohol, coco-caprylate caprate, ricinus communis castor seed oil, behentrimonium chloride, glycerin, panthenol, butyrospermum parkii shea butter, simmondsia chinensis jojoba seed oil, guar hydroxypropyltrimonium chloride, polyquaternium-10, olea europaea olive leaf extract, tilia tomentosa bud extract, arctium majus root extract, arnica montana flower extract, calendula officinalis flower extract, chamomilla recutita matricaria flower extract, citrus limon lemon peel extract, hedera helix ivy leaf extract, lamium album extract, nasturtium officinale extract, pinus sylvestris bud extract, rosmarinus officinalis rosemary leaf extract, salvia officinalis sage leaf extract, tropaeolum majus flower extract, isopropyl alcohol, pentylene glycol, tocopherol, maltodextrin, cyclodextrin, pvp, cyamopsis tetragonoloba guar gum, xanthan gum, maltodextrin vp copolymer, ethylhexylglycerin, fragrance parfum, citric acid, sodium gluconate, phytic acid, phenoxyethanol, potassium sorbate, sodium benzoate, hydroxycitronellal, citronellol",
      "buy_links": [
        {
          "url": "https://amzn.to/4fEo0CJ",
          "retailer": "Amazon",
          "country": "UK"
        },
        {
          "url": "https://curlsmith.com/products/hydrate-plump-leave-in",
          "retailer": "Curlsmith"
        },
        {
          "url": "https://uk.curlsmith.com/products/hydrate-plump-leave-in",
          "retailer": "Curlsmith",
          "country": "UK"
        }
      ],
      "asin": "B0CZVVB2C9",
      "description": "This has a small amount of isopropyl alcohol, which we mark as caution, but as it's towards the end of the ingredients list so it's unlikely to be harmful for hair.",
      "cost": 1.9,
      "id": "hydrate_&_plump_leave-in_conditioner",
      "systems_excluded": [],
      "status": "caution",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 0,
          "emollients_number": 11,
          "simple_humectants": [
            "Glycerin",
            "Panthenol",
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [],
          "emollients": [
            "Cetearyl Alcohol",
            "Castor Oil",
            "Behentrimonium Chloride",
            "Butyrospermum Parkii Shea Butter",
            "Jojoba Oil",
            "Guar Hydroxypropyltrimonium Chloride",
            "Unknown Polyquat",
            "Polyvinylpyrrolidone",
            "Guar Gum",
            "Xanthan Gum",
            "Maltodextrin VP Copolymer"
          ],
          "score": -60
        },
        "porosity": {
          "high": 100,
          "low": 55
        }
      },
      "cost_rating": "3"
    },
    "direct_leave_in_weightless_moisture_conditioner": {
      "name": "Direct Leave In Weightless Moisture Conditioner",
      "brand": "Giovanni",
      "product_categories": [
        "leave_ins"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity"
      ],
      "buy_links": [
        {
          "url": "https://amzn.to/4fK4aWC",
          "retailer": "Amazon"
        },
        {
          "url": "https://www.vitacost.com/giovanni-direct-leave-in-weightless-moisture-conditioner-for-all-hair-types",
          "retailer": "Vitacost"
        }
      ],
      "cost": 1,
      "ingredients_raw": "aqua purified water, cetyl alcohol, stearyl alcohol, tocopherol vitamin e, panthenol pro-vitamin b5, citrus grandis grapefruit fruit extract, aloe barbadensis aloe vera leaf juice, glycine soja soybean seed extract, chamomilla recutita matricaria flower extract, rosmarinus officinalis rosemary leaf extract, lavandula angustifolia lavender flower leaf stem extract, thymus vulgaris thyme extract, helianthus annuus sunflower seed oil, malva sylvestris mallow extract, cetrimonium bromide, natural fragrance, citric acid, phenoxyethanol, dehydroacetic acid, benzyl alcohol",
      "id": "direct_leave_in_weightless_moisture_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 1,
          "film_forming_humectants_number": 2,
          "emollients_number": 4,
          "simple_humectants": [
            "Panthenol"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Glycine"
          ],
          "emollients": [
            "Cetyl Alcohol",
            "Stearyl Alcohol",
            "Sunflower Oil",
            "Benzyl Alcohol"
          ],
          "score": -76
        },
        "porosity": {
          "high": 85,
          "low": 58
        }
      },
      "cost_rating": "1"
    },
    "moisture_balance_leave-in_conditioner": {
      "name": "Moisture Balance Leave-In Conditioner",
      "brand": "Bounce Curl",
      "product_categories": [
        "leave_ins"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity",
        "featured"
      ],
      "ingredients_raw": "water, cetearyl alcohol, simmondsia chinesis jojoba seed oil, ethylhexyl palmitate, olea europe olive fruit oil, glyceryl stearate, astrocaryum murumuru seed butter, argania spinosa kernel oil argan oil, butyrospermum parkii shea butter, persea gratissima avocado oil, rosa centifolia rose oil, citrus aurantium amara neroli oil, tocopheryl acetate vitamin e, behentrimonium methosulfate, cetrimonium chloride, biotin, nigella sativa virgin black cumin oil, trigonella foenum-graecum fenugreek seed extract, phenoxyethanol, ethylhexylglycerin",
      "buy_links": [
        {
          "url": "https://glnk.io/x26q/curlsbot1qg",
          "retailer": "Bounce Curl"
        }
      ],
      "id": "moisture_balance_leave-in_conditioner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 1,
          "film_forming_humectants_number": 0,
          "emollients_number": 11,
          "simple_humectants": [
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [],
          "emollients": [
            "Cetearyl Alcohol",
            "Jojoba Oil",
            "Olive Oil",
            "Argan Oil",
            "Butyrospermum Parkii Shea Butter",
            "Avocado Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Behentrimonium Methosulfate",
            "Cetrimonium Chloride",
            "Unknown Oil"
          ],
          "score": -74
        },
        "porosity": {
          "high": 91,
          "low": 0
        }
      }
    },
    "moonshine_hair_and_body_oil": {
      "name": "Moonshine Hair and Body Oil",
      "brand": "Ecoslay",
      "product_categories": [
        "oils"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity",
        "featured",
        "black_owned",
        "woman_owned",
        "small_business"
      ],
      "ingredients_raw": "jojoba oil, avocado oil, sweet almond oil, argan oil, castor oil, lemongrass essential oil, cinnamon essential oil, sweet orange essential oil, ginger essential oil, caprylhydroxamic gg",
      "buy_links": [
        {
          "url": "https://ecoslay.sjv.io/vP2ZJd",
          "retailer": "Ecoslay"
        }
      ],
      "id": "moonshine_hair_and_body_oil",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 0,
          "film_forming_humectants_number": 0,
          "emollients_number": 9,
          "simple_humectants": [],
          "film_forming_humectants": [],
          "emollients": [
            "Jojoba Oil",
            "Avocado Oil",
            "Sweet Almond Oil",
            "Argan Oil",
            "Castor Oil",
            "Unknown Essential Oil",
            "Unknown Essential Oil",
            "Unknown Essential Oil",
            "Unknown Essential Oil"
          ],
          "score": -76
        },
        "porosity": {
          "high": 29,
          "low": 0
        }
      }
    },
    "hush_nourishing_oil": {
      "name": "Hush Nourishing Oil",
      "brand": "Lohy",
      "buy_links": [
        {
          "url": "https://lohy.com.au/products/hush-finishing-oil-curly-hair?aff=49",
          "retailer": "Lohy",
          "country": "AU"
        }
      ],
      "product_categories": [
        "oils"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity",
        "featured"
      ],
      "ingredients_raw": "helianthus annuus sunflower seed oil, oenothera biennis evening primrose oil, vitis vinifera grape seed oil, simmondsia chinensis jojoba seed oil, backhousia citriodora lemon myrtle leaf oil, tocopheryl acetate, rosa canina rosehip fruit oil, macadamia ternifolia seed oil",
      "cost": 13,
      "id": "hush_nourishing_oil",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 0,
          "film_forming_humectants_number": 0,
          "emollients_number": 7,
          "simple_humectants": [],
          "film_forming_humectants": [],
          "emollients": [
            "Sunflower Oil",
            "Unknown Oil",
            "Grapeseed Oil",
            "Jojoba Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -76
        },
        "porosity": {
          "high": 25,
          "low": 0
        }
      },
      "cost_rating": "5"
    },
    "bonding_oil": {
      "name": "Bonding Oil",
      "brand": "Curlsmith",
      "product_categories": [
        "oils"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity",
        "featured"
      ],
      "ingredients_raw": "hydrogenated ethylhexyl olivate, hydrogenated olive oil unsaponifiables, coco-caprylate caprate, shea butter ethyl esters, hydrogenated castor oil sebacic acid copolymer, prunus armeniaca apricot kernel oil, hippophae rhamnoides sea buckthorn fruit oil, lens esculenta lentil seed extract, hydrolyzed cicer chickpea seed extract, chenopodium quinoa seed extract, fragrance parfum, linalool, limonene, geraniol, benzyl alcohol, citronellol",
      "buy_links": [
        {
          "url": "https://amzn.to/3DwDN9b",
          "retailer": "Amazon",
          "country": "UK"
        },
        {
          "url": "https://curlsmith.com/products/bonding-oil",
          "retailer": "Curlsmith"
        },
        {
          "url": "https://uk.curlsmith.com/products/bonding-oil",
          "retailer": "Curlsmith",
          "country": "UK"
        }
      ],
      "asin": "B09GC96P46",
      "cost": 15,
      "id": "bonding_oil",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 0,
          "film_forming_humectants_number": 0,
          "emollients_number": 6,
          "simple_humectants": [],
          "film_forming_humectants": [],
          "emollients": [
            "Olive Oil",
            "Butyrospermum Parkii Shea Butter",
            "Castor Oil",
            "Apricot Kernel Oil",
            "Unknown Oil",
            "Benzyl Alcohol"
          ],
          "score": -76
        },
        "porosity": {
          "high": 36,
          "low": 0
        }
      },
      "cost_rating": "5"
    },
    "100%_plant-derived_squalane": {
      "name": "100% Plant-Derived Squalane",
      "brand": "The Ordinary",
      "product_categories": [
        "oils",
        "pre-poo"
      ],
      "tags": [
        "featured"
      ],
      "ingredients_raw": "squalane",
      "buy_links": [
        {
          "url": "https://amzn.to/4aMfaSl",
          "retailer": "Amazon"
        },
        {
          "url": "https://theordinary.com/en-us/100-plant-derived-squalane-face-oil-100398.html",
          "retailer": "The Ordinary"
        }
      ],
      "id": "100%_plant-derived_squalane",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 0,
          "film_forming_humectants_number": 0,
          "emollients_number": 1,
          "simple_humectants": [],
          "film_forming_humectants": [],
          "emollients": [
            "Squalane"
          ],
          "score": -76
        },
        "porosity": {
          "high": 0,
          "low": 4
        }
      }
    },
    "100%_cold-pressed_virgin_marula_oil": {
      "name": "100% Cold-Pressed Virgin Marula Oil",
      "brand": "The Ordinary",
      "product_categories": [
        "oils"
      ],
      "tags": [
        "featured"
      ],
      "ingredients_raw": "Sclerocarya Birrea Seed Oil",
      "buy_links": [
        {
          "url": "https://theordinary.com/en-us/100-cold-pressed-virgin-marula-face-oil-100389.html",
          "retailer": "The Ordinary"
        },
        {
          "url": "https://amzn.to/3ErB1Td",
          "retailer": "Amazon"
        }
      ],
      "id": "100%_cold-pressed_virgin_marula_oil",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 0,
          "film_forming_humectants_number": 0,
          "emollients_number": 1,
          "simple_humectants": [],
          "film_forming_humectants": [],
          "emollients": [
            "Marula Oil"
          ],
          "score": -76
        },
        "porosity": {
          "high": 0,
          "low": 4
        }
      }
    },
    "the_ordinary_100%_organic_cold-pressed_moroccan_argan_oil": {
      "name": "The Ordinary 100% Organic Cold-Pressed Moroccan Argan Oil",
      "brand": "The Ordinary",
      "product_categories": [
        "oils"
      ],
      "tags": [
        "featured"
      ],
      "ingredients_raw": "Argania Spinosa Kernel Oil",
      "buy_links": [
        {
          "url": "https://amzn.to/3Q2MDyw",
          "retailer": "Amazon"
        },
        {
          "url": "https://theordinary.com/en-us/100-organic-cold-pressed-moroccan-argan-face-oil-100393.html",
          "retailer": "The Ordinary"
        }
      ],
      "id": "the_ordinary_100%_organic_cold-pressed_moroccan_argan_oil",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 0,
          "film_forming_humectants_number": 0,
          "emollients_number": 1,
          "simple_humectants": [],
          "film_forming_humectants": [],
          "emollients": [
            "Argan Oil"
          ],
          "score": -76
        },
        "porosity": {
          "high": 25,
          "low": 0
        }
      }
    },
    "light_oil": {
      "name": "Light Oil",
      "brand": "Bounce Curl",
      "product_categories": [
        "oils"
      ],
      "tags": [
        "featured"
      ],
      "ingredients_raw": "organic helianthus annuus sunflower seed oil, tocopheryl acetate vitamin e, xerochrysum bracteatum flower, adansonia digitata seed oil, organic argania spinosa kernel oil, organic balanites roxburghii seed oil, organic borago officinalis seed oil, organic corylus avellana hazel seed oil, passiflora edulis passion flower seed oil, organic prunus amygdalus dulcis sweet almond oil, organic rosa canina fruit oil, organic simmondsia chinensis jojoba seed oil",
      "buy_links": [
        {
          "url": "https://glnk.io/x26q/curlsbot4cu",
          "retailer": "Bounce Curl"
        }
      ],
      "id": "light_oil",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 0,
          "film_forming_humectants_number": 0,
          "emollients_number": 10,
          "simple_humectants": [],
          "film_forming_humectants": [],
          "emollients": [
            "Sunflower Oil",
            "Baobab Oil",
            "Argan Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Sweet Almond Oil",
            "Unknown Oil",
            "Jojoba Oil"
          ],
          "score": -76
        },
        "porosity": {
          "high": 31,
          "low": 0
        }
      }
    },
    "bond_curl_rehab_salve,_bond_building_strength_treatment_for_weak,_damaged_hair": {
      "name": "Bond Curl Rehab Salve, Bond Building Strength Treatment for Weak, Damaged Hair",
      "brand": "Curlsmith",
      "buy_links": [
        {
          "url": "https://amzn.to/402sONw",
          "retailer": "Amazon"
        },
        {
          "url": "https://amzn.to/429CqI3",
          "retailer": "Amazon",
          "country": "UK"
        },
        {
          "url": "https://uk.curlsmith.com/products/bond-curl-rehab-salve",
          "retailer": "Curlsmith",
          "country": "UK"
        },
        {
          "url": "https://curlsmith.com/products/bond-curl-rehab-salve",
          "retailer": "Curlsmith"
        }
      ],
      "product_categories": [
        "pre_poo"
      ],
      "tags": [
        "high_porosity",
        "featured"
      ],
      "cost": 3.75,
      "asin": "B08WPNSHCD",
      "ingredients_raw": "water aqua, cetearyl alcohol, salvia hispanica chia seed extract, creatine, polyquaternium-10, stearamidopropyl dimethylamine, lentinus edodes shiitake extract, opuntia tuna prickly pear fruit extract, cucurbita pepo pumpkin seed extract, psidium guajava guava fruit extract, prunus amygdalus dulcis sweet almond oil, ribes nigrum black currant fruit extract, brassica oleracea acephala kale leaf extract, leuconostoc radish root ferment filtrate, polyquaternium-37, hydroxypropylgluconamide, hydroxypropylammonium gluconate, disodium edta, potassium sorbate, tartaric acid, citric acid, ethylhexylglycerin, glycerin, behentrimonium chloride, phenoxyethanol, sodium benzoate, benzyl alcohol, geraniol, fragrance parfum, linalool, limonene",
      "id": "bond_curl_rehab_salve,_bond_building_strength_treatment_for_weak,_damaged_hair",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 0,
          "emollients_number": 7,
          "simple_humectants": [
            "Ethylhexylglycerin",
            "Glycerin"
          ],
          "film_forming_humectants": [],
          "emollients": [
            "Cetearyl Alcohol",
            "Unknown Polyquat",
            "Stearamidopropyl Dimethylamine",
            "Sweet Almond Oil",
            "Unknown Polyquat",
            "Behentrimonium Chloride",
            "Benzyl Alcohol"
          ],
          "score": -70
        },
        "porosity": {
          "high": 100,
          "low": 80
        }
      },
      "cost_rating": "5"
    },
    "sangria_hair_refresher": {
      "name": "Sangria Hair Refresher",
      "brand": "Ecoslay",
      "ingredients_raw": "purified water, aloe barbadensis leaf juice, vaccinium angustifolium fruit water, prunus cerasus fruit water, hhydrolyzed silk protein, sodium pca, lactobacillus ferment, lactobacillus, cocos nucifera fruit extract, amaranthus caudatus seed extract, equisetum arvense extract, panthenol, cinnamidopropyltrimonium chloride, sodium gluconate",
      "product_categories": [
        "refreshers"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity",
        "low_porosity",
        "featured",
        "black_owned"
      ],
      "buy_links": [
        {
          "url": "https://ecoslay.sjv.io/kORodn",
          "retailer": "Ecoslay"
        }
      ],
      "id": "sangria_hair_refresher",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 2,
          "emollients_number": 0,
          "simple_humectants": [
            "Sodium PCA",
            "Panthenol"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Unknown Protein"
          ],
          "emollients": [],
          "score": -84
        },
        "porosity": {
          "high": 71,
          "low": 100
        }
      }
    },
    "chai_latte_hair_cleanser": {
      "name": "Chai Latte Hair Cleanser",
      "brand": "Ecoslay",
      "ingredients_raw": "water, sodium methyl cocoyl taurate, sodium lauroyl sarcosinate, stearamidopropyl dimethylamine, black tea extract, slippery elm extract, sodium pca, propanediol, panthenol, peppermint oil, melissa leaf extract, nettle leaf extract, horsetail leaf extract, peppermint leaf extract, hydroxypropyl starch phosphate, sage extract, yucca leaf extract, burdock root extract, citric acid, lexfeel wow-a, vanilla planifolia fruit oil, ginger root oil, cinnamon leaf oil, clove flower oil, caprylhydroxamic acid gg",
      "product_categories": [
        "shampoos"
      ],
      "tags": [
        "normal_porosity",
        "featured",
        "black_owned",
        "woman_owned",
        "small_business",
        "high_porosity"
      ],
      "buy_links": [
        {
          "url": "http://ecoslay.sjv.io/gOoWn2",
          "retailer": "Ecoslay"
        }
      ],
      "id": "chai_latte_hair_cleanser",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 0,
          "emollients_number": 6,
          "simple_humectants": [
            "Sodium PCA",
            "Propanediol",
            "Panthenol"
          ],
          "film_forming_humectants": [],
          "emollients": [
            "Stearamidopropyl Dimethylamine",
            "Peppermint Oil",
            "Vanilla Planifolia Fruit Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -35
        },
        "porosity": {
          "high": 100,
          "low": 100
        }
      }
    },
    "vitalcurl+_clear_&_gentle_shampoo": {
      "name": "VitalCurl+ Clear & Gentle Shampoo",
      "brand": "Ouidad",
      "cost": 2.8,
      "product_categories": [
        "shampoos"
      ],
      "tags": [
        "low_porosity",
        "normal_porosity",
        "high_porosity"
      ],
      "ingredients_raw": "aqua water eau, sodium decylglucosides hydroxypropylsulfonate, cocamidopropyl hydroxysultaine, sodium methyl 2-sulfolaurate, cocamidopropylamine oxide, disodium 2-sulfolaurate, glycerin, helianthus annuus sunflower seed oil, salvia hispanica seed chia oil, camellia japonica tsubaki seed oil, panthenol, phospholipids, glycine soja soybean oil, glycolipids, glycine soja soybean sterols, sodium methyl cocoyl taurate, codamidopropyl pg-dimonium chloride phosphate, peg-150 distearate, ppg-2 hydroxyethyl cocamide, polyquaternium-22, butylene gycol, dmdm hydantoin, disodium edta, sodium chloride, iodopropynl butylcarbamate, citric acid, bha, hexyl cinnamal, limonene, linalool, fragrance parfum",
      "buy_links": [
        {
          "url": "https://click.linksynergy.com/link?id=9QcV0uNyab0&offerid=929395.3842998108&type=2&murl=https%3a%2f%2fwww.ouidad.com%2fproducts%2fvitalcurl-clear-and-gentle-shampoo%3fvariant%3d42433997144322",
          "retailer": "Ouidad"
        }
      ],
      "id": "vitalcurl+_clear_&_gentle_shampoo",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 1,
          "emollients_number": 5,
          "simple_humectants": [
            "Glycerin",
            "Panthenol"
          ],
          "film_forming_humectants": [
            "Glycine"
          ],
          "emollients": [
            "Sunflower Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Polyquat"
          ],
          "score": -56
        },
        "porosity": {
          "high": 67,
          "low": 100
        }
      },
      "cost_rating": "5"
    },
    "curl_shampoo": {
      "name": "Curl Shampoo",
      "brand": "Kristin Ess",
      "buy_links": [
        {
          "url": "https://amzn.to/49LHTpT",
          "retailer": "Amazon"
        },
        {
          "url": "https://www.kroger.com/p/kristin-ess-moisture-rich-curl-shampoo/0084079712927",
          "retailer": "Kroger"
        }
      ],
      "systems_excluded": [
        "curly_default"
      ],
      "product_categories": [
        "shampoos"
      ],
      "tags": [
        "normal_porosity",
        "low_porosity"
      ],
      "cost": 0.66,
      "ingredients_raw": "water, sodium c14-16 olefin sulfonate, cocamidopropyl betaine, propanediol, glycol distearate, phenoxyethanol, butyrospermum parkii shea butter, alanine, arginine, aspartic acid, glycine, histidine, isoleucine, phenylalanine, proline, serine, sodium pca, pca, sodium lactate, threonine, valine, citric acid, disodium edta, glycine soja soybean oil, glycine soja soybean sterols, glycolipids, guar hydroxypropyltrimonium chloride, hydroxyethylcellulose, hydroxyacetophenone, lauryl lactyl lactate, peg-150 distearate, phospholipids, ricinus communis castor seed oil, fragrance",
      "asin": "B09GC9CVQ8",
      "description": "This gentle shampoo cleanses while conditioning.",
      "id": "curl_shampoo",
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 4,
          "film_forming_humectants_number": 10,
          "emollients_number": 4,
          "simple_humectants": [
            "Propanediol",
            "Sodium PCA",
            "PCA",
            "Sodium Lactate"
          ],
          "film_forming_humectants": [
            "Alanine",
            "Arginine",
            "Aspartic Acid",
            "Glycine",
            "Histidine",
            "Phenylalanine",
            "Proline",
            "Serine",
            "Glycine",
            "Hydroxyethylcellulose"
          ],
          "emollients": [
            "Butyrospermum Parkii Shea Butter",
            "Unknown Oil",
            "Guar Hydroxypropyltrimonium Chloride",
            "Castor Oil"
          ],
          "score": -82
        },
        "porosity": {
          "high": 65,
          "low": 74
        }
      },
      "cost_rating": "1"
    },
    "hydrating_hairbath": {
      "name": "Hydrating Hairbath",
      "brand": "Innersense",
      "buy_links": [
        {
          "url": "https://amzn.to/3BK5x9T",
          "retailer": "Amazon"
        },
        {
          "url": "https://shop.beauty-heroes.com/products/hydrating-cream-hairbath-innersense-organic-beauty",
          "retailer": "Beauty Heroes"
        }
      ],
      "product_categories": [
        "shampoos"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity",
        "featured"
      ],
      "cost": 3,
      "ingredients_raw": "water aqua-eau, cocamidopropyl hydroxysultaine, sodium methyl cocoyl taurate, glycerin, caprylyl capryl glucoside, sodium cocoyl isethionate, glyceryl stearate se, sodium chloride, sodium lauroyl methyl isethionate, trisodium ethylenediamine disuccinate, guar hydroxypropyltrimonium chloride, plumeria actufolia flower extract, cananga odorata flower oil, lavandula angustifolia lavender oil, citrus aurantium dulcis orange peel oil, salvia sclarea clary oil, vanillin, pogostemon cablin oil, glycine soja soybean oil, sodium benzoate, pyrus malus apple fruit extract, potassium sorbate, simmondsia chinensis jojoba seed oil, oryza sativa rice extract, citric acid, hydrolyzed quinoa, hydrolyzed rice protein, calophyllum inophyllum tamanu oil, butyrospermum parkii shea butter, persia gratissima avocado oil, taraxacum officinale dandelion leaf extract, salvia officinalis sage leaf extract, melissa officinalis leaf extract, linalool, limonene",
      "asin": "B074PY4QJC",
      "id": "hydrating_hairbath",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 1,
          "film_forming_humectants_number": 1,
          "emollients_number": 11,
          "simple_humectants": [
            "Glycerin"
          ],
          "film_forming_humectants": [
            "Unknown Protein"
          ],
          "emollients": [
            "Guar Hydroxypropyltrimonium Chloride",
            "Unknown Oil",
            "Lavender Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Jojoba Oil",
            "Unknown Oil",
            "Butyrospermum Parkii Shea Butter",
            "Avocado Oil"
          ],
          "score": -59
        },
        "porosity": {
          "high": 91,
          "low": 0
        }
      },
      "cost_rating": "5"
    },
    "gentle_shampoo": {
      "name": "Gentle Shampoo",
      "brand": "MopTop",
      "ingredients_raw": "water, sodium c14-16 olefin sulfonate, cocamidopropyl betaine, cocamide mea, glycol distearate, steareth-4, glycerin, hydroxypropyltrimonium honey, silk amino acids, hypnea musciformis extract seaweed, gelidiella acerosa extract seaweed, sargassum filipendula extract seaweed, sorbitol, rosmarinus officinalis rosemary leaf extract, salix alba willow bark extract, urtica dioica nettle extract, tocopheryl acetate vitamin e, panthenol vitamin b5, guar hydroxypropyltrimonium chloride, polyquaternium-10, fragrance phthalate free, sodium phytate, sorbic acid, sodium chloride, ethylhexylglycerin, phenoxyethanol, citric acid",
      "buy_links": [
        {
          "url": "https://amzn.to/4fuIPQW",
          "retailer": "Amazon"
        }
      ],
      "cost": 2,
      "product_categories": [
        "shampoos"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity"
      ],
      "asin": "B005SIR214",
      "id": "gentle_shampoo",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 4,
          "film_forming_humectants_number": 5,
          "emollients_number": 2,
          "simple_humectants": [
            "Glycerin",
            "Sorbitol",
            "Panthenol",
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [
            "Hydroxypropyltrimonium Honey",
            "Silk Amino Acids",
            "Seaweed Extract",
            "Seaweed Extract",
            "Seaweed Extract"
          ],
          "emollients": [
            "Guar Hydroxypropyltrimonium Chloride",
            "Unknown Polyquat"
          ],
          "score": -78
        },
        "porosity": {
          "high": 100,
          "low": 100
        }
      },
      "cost_rating": "3"
    },
    "pure_harmony_hairbath": {
      "name": "Pure Harmony Hairbath",
      "brand": "Innersense",
      "ingredients_raw": "citrus medica limonum lemon peel oil, eucalyptus globulus eucalyptus, cucurbita pepo pumpkin seed oil, hydroxypropyltrimonium honey, hydrolyzed quinoa, trisodium ethylenediamine disuccinate, sodium benzoate, hydrolyzed rice protein, guar hydroxypropyltrimonium chloride, persea gratissima avocado oil, oryza sativa rice bran oil, camellia sinensis green tea leaf extract, cucumis sativus cucumber fruit extract, persea gratissima avocado fruit extract, mangifera indica mango fruit extract, water, aqua-eau, cocamidopropyl hydroxysultaine, sodium cocoyl isethionate, caprylyl capryl glucoside, glycerin, sodium chloride, sodium lauroyl methyl isethionate, butyrosepermum parkii shea butter, citrus aurantium dulcis orange peel oil",
      "buy_links": [
        {
          "url": "https://amzn.to/3ZSDywG",
          "retailer": "Amazon"
        },
        {
          "url": "https://shop.beauty-heroes.com/products/pure-harmony-hairbath-innersense-organic-beauty",
          "retailer": "Beauty Heroes"
        }
      ],
      "cost": 2.25,
      "product_categories": [
        "shampoos"
      ],
      "tags": [
        "low_porosity",
        "normal_porosity"
      ],
      "asin": "B074Q2CNMY",
      "id": "pure_harmony_hairbath",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 1,
          "film_forming_humectants_number": 2,
          "emollients_number": 7,
          "simple_humectants": [
            "Glycerin"
          ],
          "film_forming_humectants": [
            "Hydroxypropyltrimonium Honey",
            "Unknown Protein"
          ],
          "emollients": [
            "Unknown Oil",
            "Unknown Oil",
            "Guar Hydroxypropyltrimonium Chloride",
            "Avocado Oil",
            "Rice bran oil",
            "Butyrospermum Parkii Shea Butter",
            "Unknown Oil"
          ],
          "score": -82
        },
        "porosity": {
          "high": 100,
          "low": 0
        }
      },
      "cost_rating": "4"
    },
    "color_awakening_hairbath": {
      "name": "Color Awakening Hairbath",
      "brand": "Innersense",
      "ingredients_raw": "water, aqua- eau, cocamidopropyl hydroxysultaine, sodium cocoyl isethionate, caprylyl capryl glucoside, glycerin, sodium chloride, sodium lauroyl methyl isethionate, butyrospermum parkii shea butter, citrus aurantium dulcis orange peel oil, citrus medica limonum lemon peel oil, eucalyptus globulus eucalyptus, cucurbita pepo pumpkin seed oil, hydroxypropyltrimonium honey, hydrolyzed quinoa, trisodium ethylenediamine disuccinate, sodium benzoate, hydrolyzed rice protein, guar hydroxypropyltrimonium chloride, potassium sorbate, citric acid, citrus sinensis orange oil, persea gratissima avocado oil, oryza sativa rice bran oil, camellia sinensis green tea leaf extract, cucumis sativus cucumber fruit extract, persea gratissima fruit extract, mangifera indica mango fruit extract",
      "buy_links": [
        {
          "url": "https://amzn.to/41J8sKF",
          "retailer": "Amazon"
        },
        {
          "url": "https://shop.beauty-heroes.com/products/color-awakening-hairbath-innersense-organic-beauty",
          "retailer": "Beauty Heroes"
        }
      ],
      "product_categories": [
        "shampoos"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity"
      ],
      "asin": "B002RX2QFA",
      "cost": 3,
      "id": "color_awakening_hairbath",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 1,
          "film_forming_humectants_number": 2,
          "emollients_number": 8,
          "simple_humectants": [
            "Glycerin"
          ],
          "film_forming_humectants": [
            "Hydroxypropyltrimonium Honey",
            "Unknown Protein"
          ],
          "emollients": [
            "Butyrospermum Parkii Shea Butter",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Guar Hydroxypropyltrimonium Chloride",
            "Unknown Oil",
            "Avocado Oil",
            "Rice bran oil"
          ],
          "score": -71
        },
        "porosity": {
          "high": 90,
          "low": 0
        }
      },
      "cost_rating": "5"
    },
    "clarity_hairbath": {
      "name": "Clarity Hairbath",
      "brand": "Innersense",
      "ingredients_raw": "water aqua eau, aloe barbadensis leaf juice, cocamidopropyl hydroxysultaine, sodium cocoyl isethionate, glycerin, caprylyl capryl glucoside, sodium levulinate, potassium sorbate, guar hydroxypropyltrimonium chloride, citric acid, butyrospermum parkii shea butter, sodium gluconate, tocopherol, swertia japonica extract, cyperus esculentus tuber extract, symphytum officinale leaf extract, xanthan gum, coconut acid, sodium isethionate",
      "buy_links": [
        {
          "url": "https://amzn.to/4gLhRFK",
          "retailer": "Amazon"
        },
        {
          "url": "https://shop.beauty-heroes.com/products/clarity-hairbath-innersense-organicy",
          "retailer": "Beauty Heroes"
        }
      ],
      "product_categories": [
        "shampoos"
      ],
      "tags": [
        "low_porosity",
        "normal_porosity"
      ],
      "asin": "B0BHD3JKTL",
      "cost": 6,
      "id": "clarity_hairbath",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 1,
          "film_forming_humectants_number": 1,
          "emollients_number": 3,
          "simple_humectants": [
            "Glycerin"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [
            "Guar Hydroxypropyltrimonium Chloride",
            "Butyrospermum Parkii Shea Butter",
            "Xanthan Gum"
          ],
          "score": -81
        },
        "porosity": {
          "high": 100,
          "low": 56
        }
      },
      "cost_rating": "5"
    },
    "nourish_&_flourish_shampoo": {
      "name": "Nourish & Flourish Shampoo",
      "brand": "Lohy",
      "product_categories": [
        "shampoos"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity",
        "featured",
        "low_porosity"
      ],
      "buy_links": [
        {
          "url": "https://lohy.com.au/products/nourish-flourish-curly-hair-shampoo?aff=49",
          "retailer": "Lohy",
          "country": "AU"
        }
      ],
      "ingredients_raw": "aqua, lauryl glucoside, decyl glucoside, coco glucoside, cocamidopropyl betaine, glycerin, propanediol, camellia sinensis white tea leaf extract, chamomilla recutita matricaria flower leaf stem extract, citric acid, phenoxyethanol, guar hydroxypropyltrimonium chloride, hydrolysed soy protein, potassium sorbate, lemon scented tea tree oil, mandarin peel oil, rosemary oil, may chang, eucalyptus radiata, lavandin oil, salvia clary sclarea oil, pogostemon cablin patchouli oil",
      "cost": 2.3,
      "id": "nourish_&_flourish_shampoo",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 1,
          "emollients_number": 7,
          "simple_humectants": [
            "Glycerin",
            "Propanediol"
          ],
          "film_forming_humectants": [
            "Unknown Protein"
          ],
          "emollients": [
            "Guar Hydroxypropyltrimonium Chloride",
            "Tea Tree Oil",
            "Unknown Oil",
            "Rosemary Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil"
          ],
          "score": -50
        },
        "porosity": {
          "high": 100,
          "low": 31
        }
      },
      "cost_rating": "4"
    },
    "essential_moisture_cleanser": {
      "name": "Essential Moisture Cleanser",
      "brand": "Curlsmith",
      "product_categories": [
        "shampoos"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity",
        "featured"
      ],
      "ingredients_raw": "water aqua, cocamidopropyl betaine, sodium methyl cocoyl taurate, lauryl glucoside, sodium chloride, peg-120 methyl glucose trioleate, betaine, helianthus annuus sunflower seed oil, aloe barbadensis leaf juice, selaginella lepidophylla resurrection flower extract, ocimum basilicum basil leaf extract, piper nigrum black pepper seed extract, rosmarinus officinalis rosemary leaf extract, salvia officinalis sage leaf extract, carapa guaianensis andiroba seed oil, propanediol, glycerin, guar hydroxypropyltrimonium chloride, polyquaternium-10, citric acid, phenoxyethanol, sodium benzoate, potassium sorbate, fragrance parfum, limonene, linalool",
      "buy_links": [
        {
          "url": "https://amzn.to/4gzkwmm",
          "retailer": "Amazon",
          "country": "UK"
        },
        {
          "url": "https://curlsmith.com/products/essential-moisture-cleanser",
          "retailer": "Curlsmith"
        },
        {
          "url": "https://uk.curlsmith.com/products/essential-moisture-cleanser",
          "retailer": "Curlsmith",
          "country": "UK"
        }
      ],
      "asin": "B0BPTC343Q",
      "id": "essential_moisture_cleanser",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 1,
          "emollients_number": 4,
          "simple_humectants": [
            "Glucose",
            "Propanediol",
            "Glycerin"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [
            "Sunflower Oil",
            "Unknown Oil",
            "Guar Hydroxypropyltrimonium Chloride",
            "Unknown Polyquat"
          ],
          "score": -50
        },
        "porosity": {
          "high": 100,
          "low": 55
        }
      }
    },
    "full_body_weightless_cleanser": {
      "name": "Full Body Weightless Cleanser",
      "brand": "Curlsmith",
      "product_categories": [
        "shampoos"
      ],
      "tags": [
        "low_porosity",
        "normal_porosity",
        "featured"
      ],
      "ingredients_raw": "water aqua eau, glycerin, coco-glucoside, decyl glucoside, sodium methyl cocoyl taurate, xanthan gum, saccharide isomerate, guar hydroxypropyltrimonium chloride, polyquaternium-10, tilia tomentosa bud extract, olea europaea olive leaf extract, arctium majus root extract, arnica montana flower extract, calendula officinalis flower extract, chamomilla recutita matricaria flower extract, citrus limon lemon peel extract, hedera helix ivy leaf extract, lamium album extract, nasturtium officinale extract, pinus sylvestris bud extract, rosmarinus officinalis rosemary leaf extract, salvia officinalis sage leaf extract, tropaeolum majus flower extract, pentylene glycol, panthenol, tocopherol, cyclodextrin, sodium chloride, cyamopsis tetragonoloba guar gum, fragrance parfum, citric acid, sodium hydroxide, sodium gluconate, sodium citrate, phytic acid, sodium benzoate, potassium sorbate, hydroxycitronellal, citronellol",
      "buy_links": [
        {
          "url": "https://amzn.to/3Pdq0qB",
          "retailer": "Amazon",
          "country": "UK"
        },
        {
          "url": "https://curlsmith.com/products/full-body-weightless-cleanser",
          "retailer": "Curlsmith"
        },
        {
          "url": "https://uk.curlsmith.com/products/full-body-weightless-cleanser",
          "retailer": "Curlsmith",
          "country": "UK"
        }
      ],
      "asin": "B0CZW7PPLQ",
      "id": "full_body_weightless_cleanser",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 2,
          "film_forming_humectants_number": 0,
          "emollients_number": 4,
          "simple_humectants": [
            "Glycerin",
            "Panthenol"
          ],
          "film_forming_humectants": [],
          "emollients": [
            "Xanthan Gum",
            "Guar Hydroxypropyltrimonium Chloride",
            "Unknown Polyquat",
            "Guar Gum"
          ],
          "score": -26
        },
        "porosity": {
          "high": 100,
          "low": 100
        }
      }
    },
    "curl_definition_shampoo": {
      "name": "Curl Definition Shampoo",
      "brand": "Not Your Mothers Naturals",
      "ingredients_raw": "water aqua eau, sodium cocoyl isethionate, sodium lauroyl methyl isethionate, cocamidopropyl hydroxysultaine, peg-120 methyl glucose dioleate, glycol distearate, polyquaternium-10, quaternium-80, mangifera indica mango seed butter, gardenia tahitensis flower extract, glycerin, tetrasodium glutamate diacetate, fragrance parfum, linalool, hexyl cinnamal, coumarin, phenoxyethanol, ethylhexylglycerin, citric acid",
      "product_categories": [
        "shampoos"
      ],
      "tags": [
        "high porosity",
        "low porosity"
      ],
      "cost": 0.5,
      "buy_links": [
        {
          "url": "https://amzn.to/3W0nuIe",
          "retailer": "Amazon"
        },
        {
          "url": "https://www.walmart.com/ip/Not-Your-Mother-s-Naturals-Tahitian-Gardenia-Flower-and-Mango-Butter-Shampoo-15-2-fl-oz/783360566",
          "retailer": "Walmart"
        }
      ],
      "asin": "B07KQ24CZS",
      "id": "curl_definition_shampoo",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 1,
          "emollients_number": 1,
          "simple_humectants": [
            "Glucose",
            "Glycerin",
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [
            "Sodium Glutamate"
          ],
          "emollients": [
            "Unknown Polyquat"
          ],
          "score": -25
        },
        "porosity": {
          "high": 100,
          "low": 77
        }
      },
      "cost_rating": "1"
    },
    "energizing_shampoo": {
      "name": "Energizing Shampoo",
      "brand": "Curl Keeper",
      "product_categories": [
        "shampoos"
      ],
      "tags": [
        "low_porosity",
        "normal_porosity",
        "featured"
      ],
      "buy_links": [
        {
          "url": "https://frizzoff.com/r?id=idp8mh",
          "retailer": "Curl Keeper"
        },
        {
          "url": "https://amzn.to/40CsOnQ",
          "retailer": "Amazon"
        }
      ],
      "description": "Like all Curl Keeper products, this shampoo has a low pH, which helps to keep the hair cuticle closed and prevent moisture loss.",
      "ingredients_raw": "water eau, coco-glucoside, sodium chloride himalayan crystal salt, sodium c14-16 olefin sulfonate, disodium laureth sulfosuccinate, lauramide dea, panthenoil, polysorbate 80, silk amino acides, hydroxyproyl methylcellulose, citric acid, fragrance, dmdm hydantoin",
      "id": "energizing_shampoo",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 0,
          "film_forming_humectants_number": 1,
          "emollients_number": 1,
          "simple_humectants": [],
          "film_forming_humectants": [
            "Silk"
          ],
          "emollients": [
            "Unknown Oil"
          ],
          "score": -89
        },
        "porosity": {
          "high": 53,
          "low": 100
        }
      }
    },
    "smooth_as_silk™_deep_moisture_shampoo": {
      "name": "Smooth As Silk™ Deep Moisture Shampoo",
      "brand": "Giovanni",
      "product_categories": [
        "shampoos"
      ],
      "tags": [
        "low_porosity",
        "normal_porosity",
        "high_porosity"
      ],
      "buy_links": [
        {
          "url": "https://amzn.to/4h15AgY",
          "retailer": "Amazon"
        },
        {
          "url": "https://www.vitacost.com/giovanni-smooth-as-silk-deep-moisture-shampoo",
          "retailer": "Vitacost"
        }
      ],
      "description": "An excellent low-pH (~5 protects against frizz) shampoo at a great price.",
      "ingredients_raw": "aqua purified water, sodium lauroyl sarcosinate, cocamidopropyl betaine, sodium cocoamphoacetate, lauryl glucoside, decyl glucoside, sodium cocoyl glutamate, sodium lauryl glucose carboxylate, glycerin, pyrus malus apple fruit extract, aloe barbadensis aloe vera leaf juice, chamomilla recutita matricaria leaf extract, citrus aurantium dulcis valencia orange extract, citrus grandis grapefruit fruit extract, cymbopogon schoenanthus lemongrass extract, echinacea purpurea extract, glycine soja soybean seed extract, lavandula angustifolia lavender extract, rosmarinus officinalis rosemary leaf extract, macrocystis pyrifera sea kelp extract, mangifera indica mango extract, salix alba willow bark extract, xanthan gum, glycol distearate, panthenol pro-vitamin b5, citric acid, polysorbate 20, potassium sorbate, phenoxyethanol, natural fragrance",
      "id": "smooth_as_silk™_deep_moisture_shampoo",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 2,
          "emollients_number": 1,
          "simple_humectants": [
            "Glycerin",
            "Urea",
            "Panthenol"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract",
            "Glycine"
          ],
          "emollients": [
            "Xanthan Gum"
          ],
          "score": -53
        },
        "porosity": {
          "high": 89,
          "low": 100
        }
      }
    },
    "sulphate_4%_cleanser_for_body_and_hair": {
      "name": "Sulphate 4% Cleanser for Body and Hair",
      "brand": "The Ordinary",
      "product_categories": [
        "shampoos"
      ],
      "tags": [
        "featured"
      ],
      "buy_links": [
        {
          "url": "https://theordinary.com/en-us/4-sulphate-cleanser-for-body-and-hair-shampoo-100399.html",
          "retailer": "The Ordinary"
        },
        {
          "url": "https://amzn.to/4hHQm02",
          "retailer": "Amazon"
        }
      ],
      "ingredients_raw": "aqua water, sodium laureth sulfate, polysorbate 20, xanthan gum, tocopherol, phytic acid, trisodium ethylenediamine disuccinate, benzyl alcohol, ethylhexylglycerin, phenoxyethanol, chlorphenesin",
      "id": "sulphate_4%_cleanser_for_body_and_hair",
      "systems_excluded": [],
      "status": "warning",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 1,
          "film_forming_humectants_number": 0,
          "emollients_number": 2,
          "simple_humectants": [
            "Ethylhexylglycerin"
          ],
          "film_forming_humectants": [],
          "emollients": [
            "Xanthan Gum",
            "Benzyl Alcohol"
          ],
          "score": -56
        },
        "porosity": {
          "high": 74,
          "low": 100
        }
      }
    },
    "pure_silk_moisturizing_shampoo": {
      "name": "Pure Silk Moisturizing Shampoo",
      "brand": "Bounce Curl",
      "product_categories": [
        "shampoos"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity",
        "featured"
      ],
      "ingredients_raw": "water, helianthus annuus sunflower seed oil, cocamidopropyl betaine, disodium laureth sulfosuccinate, diethylhexyl sodium sulfosuccinate, glycerin panthenol polyquaternium-10, biotin, hydrolyzed quinoa, hydrolyzed adansonia digitata baobab seed protein, gluconolactone sodium benzoate, sodium laurylglucosides hydroxypropylsulfonate, lycium barbarum fruit extract, coffea arabica coffee seed extract, euterpe oleracea fruit extract, morinda citrifolia extract, punica granatum fruit extract, camellia sinensis leaf extract, garcinia mangostana fruit extract, calendula officinalis flower extract, rosmarinus officinalis rosemary leaf extract, citrus aurantium bergamia bergamot fruit oil, vanillin, hybrid safflower oil, boswellia carterii oil, pelargonium graveolens geranium oil, citrus grandis grapefruit peel oil, lavandula angustifolia lavender oil, pogostemon cablin patchouli oil, citrus aurantium dulcis orange peel oil, cocos nucifera coconut oil, citrus nobilis mandarin orange peel oil, citric acid",
      "buy_links": [
        {
          "url": "https://glnk.io/x26q/curlsbot33h",
          "retailer": "Bounce Curl"
        }
      ],
      "id": "pure_silk_moisturizing_shampoo",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 0,
          "film_forming_humectants_number": 1,
          "emollients_number": 12,
          "simple_humectants": [],
          "film_forming_humectants": [
            "Unknown Protein"
          ],
          "emollients": [
            "Sunflower Oil",
            "Unknown Polyquat",
            "Unknown Oil",
            "Safflower Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Lavender Oil",
            "Unknown Oil",
            "Unknown Oil",
            "Coconut Oil",
            "Unknown Oil"
          ],
          "score": -80
        },
        "porosity": {
          "high": 100,
          "low": 0
        }
      }
    },
    "hair_spray": {
      "name": "Hair Spray",
      "brand": "Bounce Curl",
      "product_categories": [
        "sprays"
      ],
      "tags": [
        "high_porosity",
        "normal_porosity",
        "featured"
      ],
      "ingredients_raw": "water, octylacrylamide acrylates butylaminoethyl methacyrlate copolymer, heptyl glucoside, panthenol, aminomethyl propanol, aloe barbadensis leaf extract, panax ginseng root extract, salvia officinalis sage extract, nigella sativa virgin black cumin oil boswellia carterii oil, caprylhydroxamic acid, propanediol, caprylyl glycol, fragrance, citric acid",
      "buy_links": [
        {
          "url": "https://glnk.io/x26q/curlsbot0la",
          "retailer": "Bounce Curl"
        }
      ],
      "id": "hair_spray",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 3,
          "film_forming_humectants_number": 1,
          "emollients_number": 2,
          "simple_humectants": [
            "Panthenol",
            "Propanediol",
            "Caprylyl Glycol"
          ],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [
            "Copolymer",
            "Unknown Oil"
          ],
          "score": -52
        },
        "porosity": {
          "high": 81,
          "low": 66
        }
      }
    },
    "ginger_and_moringa_tea_rinse": {
      "name": "Ginger and Moringa Tea Rinse",
      "brand": "Ecoslay",
      "product_categories": [
        "treatments"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity",
        "low_porosity",
        "featured",
        "black_owned",
        "woman_owned",
        "small_business"
      ],
      "ingredients_raw": "ginger extract, moringa extract, aloe vera juice, apple cider vinegar, optiphen plus",
      "buy_links": [
        {
          "url": "https://ecoslay.sjv.io/APKENx",
          "retailer": "Ecoslay"
        }
      ],
      "id": "ginger_and_moringa_tea_rinse",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 0,
          "film_forming_humectants_number": 1,
          "emollients_number": 0,
          "simple_humectants": [],
          "film_forming_humectants": [
            "Aloe Barbadensis Leaf Extract"
          ],
          "emollients": [],
          "score": -96
        },
        "porosity": {
          "high": 100,
          "low": 100
        }
      }
    },
    "matcha_boost_protein_strengthening_treatment": {
      "name": "Matcha Boost Protein Strengthening Treatment",
      "brand": "Ecoslay",
      "product_categories": [
        "treatments"
      ],
      "tags": [
        "normal_porosity",
        "high_porosity",
        "featured",
        "black_owned",
        "woman_owned",
        "small_business"
      ],
      "ingredients_raw": "distilled water, ceteryl alcohol, behentrimonium methosulfate, hydrolyzed quinoa protein, hydrolyzed keratin protein, matcha extract, propanediol, hp starch, caprylhydroxamic acid gg preservation blend caprylhydroxamic acid, glyceryl",
      "buy_links": [
        {
          "url": "http://ecoslay.sjv.io/yqrm1b",
          "retailer": "Ecoslay"
        }
      ],
      "id": "matcha_boost_protein_strengthening_treatment",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 1,
          "film_forming_humectants_number": 2,
          "emollients_number": 2,
          "simple_humectants": [
            "Propanediol"
          ],
          "film_forming_humectants": [
            "Unknown Protein",
            "Hydrolyzed keratin"
          ],
          "emollients": [
            "Cetearyl Alcohol",
            "Behentrimonium Methosulfate"
          ],
          "score": -82
        },
        "porosity": {
          "high": 100,
          "low": 69
        }
      }
    },
    "multi-peptide_serum_for_hair_density": {
      "name": "Multi-Peptide Serum for Hair Density",
      "brand": "The Ordinary",
      "product_categories": [
        "treatments"
      ],
      "tags": [
        "featured"
      ],
      "ingredients_raw": "aqua water, propanediol, butylene glycol, glycerin, caffeine, biotinoyl tripeptide-1, acetyl tetrapeptide-3, larix europaea wood extract, pisum sativum extract, scutellaria baicalensis root extract, triticum vulgare germ extract, glycine soja germ extract, trifolium pratense flower extract, camellia sinensis leaf extract, apigenin, oleanolic acid, arginine, glycine, calcium gluconate, zinc chloride, lactic acid, gluconolactone, dextran, maltodextrin, hydroxyethylcellulose, xanthan gum, pentylene glycol, dimethyl isosorbide, polysorbate 20, ppg-26-buteth-26, peg-40 hydrogenated castor oil, trisodium ethylenediamine disuccinate, sodium metabisulfite, sodium benzoate, phenoxyethanol, chlorphenesin",
      "buy_links": [
        {
          "url": "https://theordinary.com/en-us/multi-peptide-serum-for-hair-density-hair-scalp-treatment-100434.html",
          "retailer": "The Ordinary"
        },
        {
          "url": "https://amzn.to/3CxvRo9",
          "retailer": "Amazon"
        }
      ],
      "id": "multi-peptide_serum_for_hair_density",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 4,
          "film_forming_humectants_number": 6,
          "emollients_number": 2,
          "simple_humectants": [
            "Propanediol",
            "Butylene glycol",
            "Glycerin",
            "Lactic Acid"
          ],
          "film_forming_humectants": [
            "Peptide",
            "Peptide",
            "Glycine",
            "Arginine",
            "Glycine",
            "Hydroxyethylcellulose"
          ],
          "emollients": [
            "Xanthan Gum",
            "Castor Oil"
          ],
          "score": -43
        },
        "porosity": {
          "high": 59,
          "low": 54
        }
      }
    },
    "natural_moisturizing_factors_+_ha_for_scalp": {
      "name": "Natural Moisturizing Factors + HA for Scalp",
      "brand": "The Ordinary",
      "product_categories": [
        "treatments"
      ],
      "tags": [
        "featured"
      ],
      "buy_links": [
        {
          "url": "https://theordinary.com/en-us/natural-moisturizing-factors-ha-for-scalp-hair-scalp-treatment-100422.html",
          "retailer": "The Ordinary"
        },
        {
          "url": "https://amzn.to/4hqGzvY",
          "retailer": "Amazon"
        }
      ],
      "ingredients_raw": "aqua water, squalane, c12-13 alkyl glyceryl hydrolyzed hyaluronate, arginine, aspartic acid, glycine, alanine, serine, valine, isoleucine, proline, threonine, histidine, phenylalanine, glutamic acid, glucose, fructose, sucrose, pca, sodium pca, zinc pca, magnesium pca, manganese pca, urea, sodium lactate, lactic acid, hexyl nicotinate, lauryl glucoside, myristyl glucoside, polyglyceryl-6 laurate, isoceteth-20, dextrin, hexylene glycol, potassium sorbate, phenoxyethanol, chlorphenesin",
      "id": "natural_moisturizing_factors_+_ha_for_scalp",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 11,
          "film_forming_humectants_number": 9,
          "emollients_number": 1,
          "simple_humectants": [
            "Glucose",
            "Fructose",
            "PCA",
            "Sodium PCA",
            "PCA",
            "PCA",
            "PCA",
            "Urea",
            "Sodium Lactate",
            "Lactic Acid",
            "Hexylene Glycol"
          ],
          "film_forming_humectants": [
            "Arginine",
            "Aspartic Acid",
            "Glycine",
            "Alanine",
            "Serine",
            "Proline",
            "Histidine",
            "Phenylalanine",
            "Glutamic Acid"
          ],
          "emollients": [
            "Squalane"
          ],
          "score": -82
        },
        "porosity": {
          "high": 49,
          "low": 38
        }
      }
    },
    "glycolic_acid_7%_exfoliating_toner": {
      "name": "Glycolic Acid 7% Exfoliating Toner",
      "brand": "The Ordinary",
      "product_categories": [
        "treatments"
      ],
      "tags": [
        "featured"
      ],
      "buy_links": [
        {
          "url": "https://theordinary.com/en-us/glycolic-acid-7-exfoliating-toner-100418.html",
          "retailer": "The Ordinary"
        },
        {
          "url": "https://amzn.to/3CMuIJj",
          "retailer": "Amazon"
        }
      ],
      "ingredients_raw": "aqua water, glycolic acid, rosa damascena flower water, centaurea cyanus flower water, aloe barbadensis leaf water, propanediol, glycerin, triethanolamine, aminomethyl propanol, panax ginseng root extract, tasmannia lanceolata fruit leaf extract, aspartic acid, alanine, glycine, serine, valine, isoleucine, proline, threonine, histidine, phenylalanine, glutamic acid, arginine, pca, sodium pca, sodium lactate, fructose, glucose, sucrose, urea, hexyl nicotinate, dextrin, citric acid, polysorbate 20, gellan gum, trisodium ethylenediamine disuccinate, sodium chloride, hexylene glycol, potassium sorbate, sodium benzoate, 1, 2-hexanediol, caprylyl glycol",
      "id": "glycolic_acid_7%_exfoliating_toner",
      "systems_excluded": [],
      "status": "ok",
      "extensions": {
        "frizzbot": {
          "simple_humectants_number": 10,
          "film_forming_humectants_number": 9,
          "emollients_number": 0,
          "simple_humectants": [
            "Propanediol",
            "Glycerin",
            "PCA",
            "Sodium PCA",
            "Sodium Lactate",
            "Fructose",
            "Glucose",
            "Urea",
            "Hexylene Glycol",
            "Caprylyl Glycol"
          ],
          "film_forming_humectants": [
            "Aspartic Acid",
            "Alanine",
            "Glycine",
            "Serine",
            "Proline",
            "Histidine",
            "Phenylalanine",
            "Glutamic Acid",
            "Arginine"
          ],
          "emollients": [],
          "score": -62
        },
        "porosity": {
          "high": 50,
          "low": 69
        }
      }
    }
  }
};

export function getBundledProducts(): ProductDatabase {
  return defaultProductDatabase;
}
